export const addresses = [
  {
    title: "МО, г.Балашиха, ул.Свердлова,  д.7",
    coord: [55.820223, 37.967224],
    descr: "МО, г.Балашиха, ул.Свердлова,  д.7"
  },
  {
    title: "МО, г. Балашиха, микр-он Янтарный, ул. Кольцевая, дом 3, корп. 2",
    coord: [55.822544, 37.87564],
    descr: "МО, г. Балашиха, микр-он Янтарный, ул. Кольцевая, дом 3, корп. 2"
  },
  {
    title: "МО г. Балашиха,ул Зеленая д.32 корп 2 ,ТЦ Жемчужина",
    coord: [55.808103, 37.943104],
    descr: "МО г. Балашиха,ул Зеленая д.32 корп 2 ,ТЦ Жемчужина"
  },
  {
    title: "г. Москва, ул. 2-я Синичкина, д.9 А",
    coord: [55.760879, 37.718076],
    descr: "г. Москва, ул. 2-я Синичкина, д.9 А"
  },
  {
    title: "г.Москва , Фрязевская 3, к1",
    coord: [55.745478, 37.817726],
    descr: "г.Москва , Фрязевская 3, к1"
  },
  {
    title: "г.Москва, ул. Саянская, д. 8 А",
    coord: [55.767094, 37.828766],
    descr: "г.Москва, ул. Саянская, д. 8 А"
  },
  {
    title: "г. Москва, ул. Зеленый проспект, дом 62 А",
    coord: [55.750824, 37.820331],
    descr: "г. Москва, ул. Зеленый проспект, дом 62 А"
  },
  {
    title: "МО, Электросталь, ул. Ялагина,3",
    coord: [55.767828, 38.432982],
    descr: "МО, Электросталь, ул. Ялагина,3"
  },
  {
    title: "МО, г. Железнодорожный, Кучино, ул.Центральная, д.68, стр1",
    coord: [55.751313, 37.954297],
    descr: "МО, г. Железнодорожный, Кучино, ул.Центральная, д.68, стр1"
  },
  {
    title: "МО, г. Реутов, ул. Октября, вл.10",
    coord: [55.751923, 37.859309],
    descr: "МО, г. Реутов, ул. Октября, вл.10"
  },
  {
    title: "МО, г. Реутов, ул. Южная, д.10 А",
    coord: [55.74716, 37.862148],
    descr: "МО, г. Реутов, ул. Южная, д.10 А"
  },
  {
    title: "Москоская обл.М-р КУЧИНО улица РЕЧНАЯ дом 3А",
    coord: [55.747834, 37.960405],
    descr: "Москоская обл.М-р КУЧИНО улица РЕЧНАЯ дом 3А"
  },
  {
    title: "МО, г.Балашиха, мкр. Железнодорожный, ул. Пролетарская 2/2, пом. 1",
    coord: [55.750282, 38.00683],
    descr: "МО, г.Балашиха, мкр. Железнодорожный, ул. Пролетарская 2/2, пом. 1"
  },
  {
    title: "МО, г.Балашиха,  микрорайон 1 мая, д. 4",
    coord: [55.80915, 37.841388],
    descr: "МО, г.Балашиха,  микрорайон 1 мая, д. 4"
  },
  {
    title: "МО, г. Балашиха, Шоссе Энтузиастов, д.36 А",
    coord: [55.793733, 37.939268],
    descr: "МО, г. Балашиха, Шоссе Энтузиастов, д.36 А"
  },
  {
    title: "МО, г. Старая Купавна, ул. Акрихиновское шоссе, дом 12",
    coord: [55.818483, 38.17389],
    descr: "МО, г. Старая Купавна, ул. Акрихиновское шоссе, дом 12"
  },
  {
    title: "г.Москва, ул. Новокосинская, д.14 А",
    coord: [55.737796, 37.857045],
    descr: "г.Москва, ул. Новокосинская, д.14 А"
  },
  {
    title: "г. Москва, ул. Магнитогорская, дом 2",
    coord: [55.772644, 37.82131],
    descr: "г. Москва, ул. Магнитогорская, дом 2"
  },
  {
    title: "143433, р-п Нахабино ул.Новая д.11А",
    coord: [55.843066, 37.137442],
    descr: "143433, р-п Нахабино ул.Новая д.11А"
  },
  {
    title: "МО, Павловская слобода ул. Ленина ,73",
    coord: [55.814452, 37.071765],
    descr: "МО, Павловская слобода ул. Ленина ,73"
  },
  {
    title: "МО, Истринский р-н, ПГТ Снегири, ул. Московская, д. 12",
    coord: [55.887766, 37.037099],
    descr: "МО, Истринский р-н, ПГТ Снегири, ул. Московская, д. 12"
  },
  {
    title: "МО, г.Красногорск, ул. Авангардная, д.3",
    coord: [55.814431, 37.361912],
    descr: "МО, г.Красногорск, ул. Авангардная, д.3"
  },
  {
    title: "г.Красногорск, Подмосковный б-р д.9",
    coord: [55.821967, 37.36979],
    descr: "г.Красногорск, Подмосковный б-р д.9"
  },
  {
    title: "МО, г. Красногорск, Знаменская ул., 5 ТРЦ Июнь",
    coord: [55.818882, 37.346739],
    descr: "МО, г. Красногорск, Знаменская ул., 5 ТРЦ Июнь"
  },
  {
    title: "МО г. Красногорск ул.Ленина, д 2",
    coord: [55.819454, 37.320248],
    descr: "МО г. Красногорск ул.Ленина, д 2"
  },
  {
    title: "г.Москва, ул.Дубравная, д.34/29",
    coord: [55.846082, 37.35795],
    descr: "г.Москва, ул.Дубравная, д.34/29"
  },
  {
    title: "г.Москва, ул.Маршала Катукова, д. 18",
    coord: [55.806752, 37.406531],
    descr: "г.Москва, ул.Маршала Катукова, д. 18"
  },
  {
    title: "МО Солнечногорский р-н д.Брехово стр.66 М",
    coord: [55.927352, 37.1962],
    descr: "МО Солнечногорский р-н д.Брехово стр.66 М"
  },
  {
    title: "г.Москва, ул.Маршала Катукова, д. 25",
    coord: [55.805513, 37.414427],
    descr: "г.Москва, ул.Маршала Катукова, д. 25"
  },
  {
    title: "МО,Истринский р-н,Дедовск г,,Ногина ул,4",
    coord: [55.861242, 37.127991],
    descr: "МО,Истринский р-н,Дедовск г,,Ногина ул,4"
  },
  {
    title: "г.Москва, ул. Туристская 13 к 2",
    coord: [55.850019, 37.421874],
    descr: "г.Москва, ул. Туристская 13 к 2"
  },
  {
    title: "МО,  г. Мытищи, Шараповский проезд, вл.2",
    coord: [55.916678, 37.759264],
    descr: "МО,  г. Мытищи, Шараповский проезд, вл.2"
  },
  {
    title: "МО, г.Мытищи, Олимпийский пр-т д.10",
    coord: [55.916386, 37.772379],
    descr: "МО, г.Мытищи, Олимпийский пр-т д.10"
  },
  {
    title: "МО,  г. Мытищи, ул. Селезнева , д. 33",
    coord: [55.89183, 37.727607],
    descr: "МО,  г. Мытищи, ул. Селезнева , д. 33"
  },
  {
    title: "МО г.Мытищи ул.Троицкая 7",
    coord: [55.90519, 37.699921],
    descr: "МО г.Мытищи ул.Троицкая 7"
  },
  {
    title: "г.Мытищи ул.Мира 32/2",
    coord: [55.921955, 37.71795],
    descr: "г.Мытищи ул.Мира 32/2"
  },
  {
    title: "МО, г.Мытищи, Новомытищинский пр-кт д.49 корп.1",
    coord: [55.91858, 37.724921],
    descr: "МО, г.Мытищи, Новомытищинский пр-кт д.49 корп.1"
  },
  {
    title: "МО г.Мытищи ул.Мира 30",
    coord: [55.91858, 37.724921],
    descr: "МО г.Мытищи ул.Мира 30"
  },
  {
    title: "МО, Мытищи, ул. Летная, 40А",
    coord: [55.904271, 37.711204],
    descr: "МО, Мытищи, ул. Летная, 40А"
  },
  {
    title: "МО Мытищи Осташковское ш 22",
    coord: [55.898322, 37.671676],
    descr: "МО Мытищи Осташковское ш 22"
  },
  {
    title: "МО, г. Мытищи, ул.Совхозная 20г.",
    coord: [55.970474, 37.744172],
    descr: "МО, г. Мытищи, ул.Совхозная 20г."
  },
  {
    title: "МО, г.Мытищи, Олимпийский пр-кт д.21",
    coord: [55.925107, 37.754224],
    descr: "МО, г.Мытищи, Олимпийский пр-кт д.21"
  },
  {
    title: "МО, Мытищинский р-н, г.Мытищи, ул.Рождественская 11",
    coord: [55.918807, 37.756281],
    descr: "МО, Мытищинский р-н, г.Мытищи, ул.Рождественская 11"
  },
  {
    title: "МО, г. Мытищи, Новомытищинский пр-т,  д. 31 А",
    coord: [55.905482, 37.728487],
    descr: "МО, г. Мытищи, Новомытищинский пр-т,  д. 31 А"
  },
  {
    title: "г. Зеленоград, мкр 15, кор.1549",
    coord: [55.977949, 37.15503],
    descr: "г. Зеленоград, мкр 15, кор.1549"
  },
  {
    title: "г Москва г.Зеленоград корп 900, мкр 9",
    coord: [55.981329, 37.184261],
    descr: "г Москва г.Зеленоград корп 900, мкр 9"
  },
  {
    title: "МО, г. Зеленоград, Панфиловский пр-т. д.6а",
    coord: [56.008797, 37.200044],
    descr: "МО, г. Зеленоград, Панфиловский пр-т. д.6а"
  },
  {
    title: "г.Москва, ул. Планерная, д. 7",
    coord: [55.862984, 37.434882],
    descr: "г.Москва, ул. Планерная, д. 7"
  },
  {
    title: "г.Москва,  Сходненская, 56",
    coord: [55.850408, 37.44409],
    descr: "г.Москва,  Сходненская, 56"
  },
  {
    title: "МО Истринский р-н, с/пос. Бужаровское, д. Сафонтьево, д.62",
    coord: [55.977524, 36.835273],
    descr: "МО Истринский р-н, с/пос. Бужаровское, д. Сафонтьево, д.62"
  },
  {
    title: "г.Москва, Пятницкое шоссе д.3",
    coord: [55.835862, 37.385852],
    descr: "г.Москва, Пятницкое шоссе д.3"
  },
  {
    title: "г.Москва, Строгинский бульвар, д. 1/2",
    coord: [55.805776, 37.396802],
    descr: "г.Москва, Строгинский бульвар, д. 1/2"
  },
  {
    title: "г.Зеленоград 23 микрорайон кор.2309А",
    coord: [55.964524, 37.187109],
    descr: "г.Зеленоград 23 микрорайон кор.2309А"
  },
  {
    title: "г.Москва, г.Зеленоград корп.406,мкр 4",
    coord: [55.998227, 37.210115],
    descr: "г.Москва, г.Зеленоград корп.406,мкр 4"
  },
  {
    title: "г.Москва, ул. Генерала Белобородова д.14/1",
    coord: [55.835468, 37.354402],
    descr: "г.Москва, ул. Генерала Белобородова д.14/1"
  },
  {
    title: "г. Москва, ул. Митинская, д.21",
    coord: [55.843323, 37.3652],
    descr: "г. Москва, ул. Митинская, д.21"
  },
  {
    title: "г.Зеленоград, кор.1446,мкр 14",
    coord: [55.98496, 37.151706],
    descr: "г.Зеленоград, кор.1446,мкр 14"
  },
  {
    title: "г.Москва г, Зеленоград г, Юности пл, 2, стр.1",
    coord: [56.002279, 37.211004],
    descr: "г.Москва г, Зеленоград г, Юности пл, 2, стр.1"
  },
  {
    title: "г.Москва Зеленоград корпус 1471 Б",
    coord: [55.988394, 37.155695],
    descr: "г.Москва Зеленоград корпус 1471 Б"
  },
  {
    title: "Москва, ул. Хабаровская, д.15",
    coord: [55.822498, 37.823358],
    descr: "Москва, ул. Хабаровская, д.15"
  },
  {
    title: "г.Москва, Измайловское шоссе д. 71 А",
    coord: [55.789563, 37.752526],
    descr: "г.Москва, Измайловское шоссе д. 71 А"
  },
  {
    title: "г. Москва, ул. 3-я Парковая, вл. 24",
    coord: [55.794968, 37.783734],
    descr: "г. Москва, ул. 3-я Парковая, вл. 24"
  },
  {
    title: "г.Москва г, Первомайская ул, 42",
    coord: [55.792265, 37.78712],
    descr: "г.Москва г, Первомайская ул, 42"
  },
  {
    title: "г.Москва. ул.Академика Янгеля, д8а",
    coord: [55.596696, 37.589814],
    descr: "г.Москва. ул.Академика Янгеля, д8а"
  },
  {
    title: "г. Москва, ул. Вешняковская 18",
    coord: [55.724124, 37.825155],
    descr: "г. Москва, ул. Вешняковская 18"
  },
  {
    title: "г. Москва Каширское шоссе 80",
    coord: [55.624505, 37.709093],
    descr: "г. Москва Каширское шоссе 80"
  },
  {
    title: "г.Москва, пр-т. Андропова, д. 36",
    coord: [55.675885, 37.66203],
    descr: "г.Москва, пр-т. Андропова, д. 36"
  },
  {
    title: "г.Москва, Каширское шоссе, д. 26",
    coord: [55.653319, 37.646139],
    descr: "г.Москва, Каширское шоссе, д. 26"
  },
  {
    title: "г.Москва, Алтуфьевское шоссе, д. 70 к.1",
    coord: [55.888296, 37.588683],
    descr: "г.Москва, Алтуфьевское шоссе, д. 70 к.1"
  },
  {
    title: "г.Москва, ул.Пришвина, 22",
    coord: [55.885575, 37.602166],
    descr: "г.Москва, ул.Пришвина, 22"
  },
  {
    title: "Москва, Алтуфьевское шоссе, д.95",
    coord: [55.901955, 37.585628],
    descr: "Москва, Алтуфьевское шоссе, д.95"
  },
  {
    title: "Москва, ул. Римского-Корсакова, д.20",
    coord: [55.874329, 37.60982],
    descr: "Москва, ул. Римского-Корсакова, д.20"
  },
  {
    title: "г.Москва, Новый арбат, д. 15 (Москвичка)",
    coord: [55.752141, 37.59242],
    descr: "г.Москва, Новый арбат, д. 15 (Москвичка)"
  },
  {
    title: "г.Москва, ул.Нижегородская д.2 стр.1",
    coord: [55.738465, 37.674508],
    descr: "г.Москва, ул.Нижегородская д.2 стр.1"
  },
  {
    title: "г.Москва, ул. Краснопрудная, д 13А",
    coord: [55.780431, 37.666189],
    descr: "г.Москва, ул. Краснопрудная, д 13А"
  },
  {
    title: "г.Москва, ул. Большая Семеновская, д.16",
    coord: [55.782076, 37.704125],
    descr: "г.Москва, ул. Большая Семеновская, д.16"
  },
  {
    title: "г.Москва, ул. Юных Ленинцев, 12",
    coord: [55.699294, 37.741064],
    descr: "г.Москва, ул. Юных Ленинцев, 12"
  },
  {
    title: "Москва, Новомарьинская, 14/15",
    coord: [55.654234, 37.7585],
    descr: "Москва, Новомарьинская, 14/15"
  },
  {
    title: "г.Москва, ул Сормовская, д.6.",
    coord: [55.710763, 37.812022],
    descr: "г.Москва, ул Сормовская, д.6."
  },
  {
    title: "г. Москва,  Рязанский проспект, дом 14, корп. 2",
    coord: [55.724814, 37.762516],
    descr: "г. Москва,  Рязанский проспект, дом 14, корп. 2"
  },
  {
    title: "г. Москва, ул. Волжский б-р, дом 7",
    coord: [55.716585, 37.745708],
    descr: "г. Москва, ул. Волжский б-р, дом 7"
  },
  {
    title: "г. Москва, ул. Рязанский проспект, дом 30",
    coord: [55.718856, 37.779835],
    descr: "г. Москва, ул. Рязанский проспект, дом 30"
  },
  {
    title: "г.Москва, ул.Люблинская д. 169, кор.2",
    coord: [55.649063, 37.744944],
    descr: "г.Москва, ул.Люблинская д. 169, кор.2"
  },
  {
    title: "г.Москва, ул. Зеленодольская, д. 40",
    coord: [55.704098, 37.765785],
    descr: "г.Москва, ул. Зеленодольская, д. 40"
  },
  {
    title: "г.Москва, Рязанский проспект, д. 28, стр. 1",
    coord: [55.719105, 37.779027],
    descr: "г.Москва, Рязанский проспект, д. 28, стр. 1"
  },
  {
    title: "г. Москва, ул. Краснодарская, дом 51, корп. 2",
    coord: [55.677341, 37.765408],
    descr: "г. Москва, ул. Краснодарская, дом 51, корп. 2"
  },
  {
    title: "г. Москва, ул. Борисовские пруды, дом 26",
    coord: [55.639964, 37.758213],
    descr: "г. Москва, ул. Борисовские пруды, дом 26"
  },
  {
    title: "г.Москва, ул.Маршала Полубоярова, 16 к.1",
    coord: [55.685259, 37.86257],
    descr: "г.Москва, ул.Маршала Полубоярова, 16 к.1"
  },
  {
    title: "г.Москва, ул. Генерала Кузнецова, д.25,кор1",
    coord: [55.681864, 37.853479],
    descr: "г.Москва, ул. Генерала Кузнецова, д.25,кор1"
  },
  {
    title: "Москва ул.Никулинская д.21",
    coord: [55.66898, 37.453531],
    descr: "Москва ул.Никулинская д.21"
  },
  {
    title: "г. Москва, ул. Генерала Кузнецова, дом 22",
    coord: [55.685919, 37.853964],
    descr: "г. Москва, ул. Генерала Кузнецова, дом 22"
  },
  {
    title: "г.Москва, ул.Братиславская, д.27 к.1",
    coord: [55.654538, 37.765561],
    descr: "г.Москва, ул.Братиславская, д.27 к.1"
  },
  {
    title: "г. Москва, г.Щербинка, ул.Железнодорожная, д.44",
    coord: [55.498989, 37.567922],
    descr: "г. Москва, г.Щербинка, ул.Железнодорожная, д.44"
  },
  {
    title: "г.Москва Варшавское шоссе, д 160",
    coord: [55.582991, 37.595249],
    descr: "г.Москва Варшавское шоссе, д 160"
  },
  {
    title: "г.Москва, ул.Бирюлёвская, 51 к.1",
    coord: [55.582655, 37.671507],
    descr: "г.Москва, ул.Бирюлёвская, 51 к.1"
  },
  {
    title: "МО, г. Видное, микрорайон Солнечный, д.10.",
    coord: [55.551746, 37.702544],
    descr: "МО, г. Видное, микрорайон Солнечный, д.10."
  },
  {
    title: "г.Москва, ул. Лебедянская, 17",
    coord: [55.587372, 37.669854],
    descr: "г.Москва, ул. Лебедянская, 17"
  },
  {
    title: "г. Москва, ул. Медынская, д. 7",
    coord: [55.587372, 37.669854],
    descr: "г. Москва, ул. Медынская, д. 7"
  },
  {
    title: "г.Москва Варшавское шоссе, д.87 б",
    coord: [55.653644, 37.620698],
    descr: "г.Москва Варшавское шоссе, д.87 б"
  },
  {
    title: "г. Москва,  ул Каховка 27",
    coord: [55.655458, 37.57201],
    descr: "г. Москва,  ул Каховка 27"
  },
  {
    title: "г.Москва, ул.Азовская, д.24, корп.3",
    coord: [55.647539, 37.595555],
    descr: "г.Москва, ул.Азовская, д.24, корп.3"
  },
  {
    title: "Москва ул. Тихвинская ,17 стр 1",
    coord: [55.789446, 37.599606],
    descr: "Москва ул. Тихвинская ,17 стр 1"
  },
  {
    title: "г.Москва, Щелковское шоссе, дом 2 А",
    coord: [55.803135, 37.757862],
    descr: "г.Москва, Щелковское шоссе, дом 2 А"
  },
  {
    title: "г.Москва,  Русаковская д.31",
    coord: [55.788576, 37.678685],
    descr: "г.Москва,  Русаковская д.31"
  },
  {
    title: "МО г Щелково Пролетарский пр д 4 к 2",
    coord: [55.91631, 37.99676],
    descr: "МО г Щелково Пролетарский пр д 4 к 2"
  },
  {
    title: "г. Москва, ул. Краснобогатырская, дом 90,стр. 2",
    coord: [55.800428, 37.710063],
    descr: "г. Москва, ул. Краснобогатырская, дом 90,стр. 2"
  },
  {
    title: "г.Москва, Заревый пр-д, 14/12",
    coord: [55.887241, 37.656155],
    descr: "г.Москва, Заревый пр-д, 14/12"
  },
  {
    title: "г.Москва,  ул.Алтуфьевское шоссе,  д. 8",
    coord: [55.852768, 37.585817],
    descr: "г.Москва,  ул.Алтуфьевское шоссе,  д. 8"
  },
  {
    title: "г.Москва ул.Алтуфьевское шоссе 22 Б",
    coord: [55.8611, 37.585556],
    descr: "г.Москва ул.Алтуфьевское шоссе 22 Б"
  },
  {
    title: "г.Москва, Дмитровское шоссе, д. 89",
    coord: [55.863833, 37.545581],
    descr: "г.Москва, Дмитровское шоссе, д. 89"
  },
  {
    title: "МО г.Долгопрудный Стародмитровское шоссе д.2 стр.1",
    coord: [55.966635, 37.531809],
    descr: "МО г.Долгопрудный Стародмитровское шоссе д.2 стр.1"
  },
  {
    title: "г.Москва, ул. Плещеева, д. 4",
    coord: [55.883742, 37.606514],
    descr: "г.Москва, ул. Плещеева, д. 4"
  },
  {
    title: "г.Москва, ул. Широкая, д. 9, кор. 1",
    coord: [55.883742, 37.606514],
    descr: "г.Москва, ул. Широкая, д. 9, кор. 1"
  },
  {
    title: "г.Москва, ул.Сухонская, д.9",
    coord: [55.877183, 37.65249],
    descr: "г.Москва, ул.Сухонская, д.9"
  },
  {
    title: "г. Москва, ул. Дубнинская, 30",
    coord: [55.877354, 37.558957],
    descr: "г. Москва, ул. Дубнинская, 30"
  },
  {
    title: "г. Москва, ул. Софьи Ковалевской д.2",
    coord: [55.877092, 37.534101],
    descr: "г. Москва, ул. Софьи Ковалевской д.2"
  },
  {
    title: "г.Москва, Дмитровское шоссе, д.13, кор.1",
    coord: [55.818129, 37.573214],
    descr: "г.Москва, Дмитровское шоссе, д.13, кор.1"
  },
  {
    title: "г.Москва Дмитровское шоссе  д 73 стр 3",
    coord: [55.856972, 37.557745],
    descr: "г.Москва Дмитровское шоссе  д 73 стр 3"
  },
  {
    title: "МО, г.Люберцы, Октябрьский пр-т, д.146",
    coord: [55.679854, 37.889465],
    descr: "МО, г.Люберцы, Октябрьский пр-т, д.146"
  },
  {
    title: "МО, г.Люберцы, ул. Побратимов. Д 7",
    coord: [55.692115, 37.8964],
    descr: "МО, г.Люберцы, ул. Побратимов. Д 7"
  },
  {
    title: "МО, Люберецкий р-он., г.Люберцы., Новорязанское шоссе 23-й км., владение 9",
    coord: [55.650420, 37.908382],
    descr: "МО, Люберецкий р-он., г.Люберцы., Новорязанское шоссе 23-й км., владение 9"
  },
  {
    title: "МО, г. Люберцы, Новорязанское шоссе, дом 7",
    coord: [55.669899, 37.871373],
    descr: "МО, г. Люберцы, Новорязанское шоссе, дом 7"
  },
  {
    title: "МО, г. Голицыно, Привокзальная площадь, д.5",
    coord: [55.616275, 36.988267],
    descr: "МО, г. Голицыно, Привокзальная площадь, д.5"
  },
  {
    title: "г. Москва, г.Троицк. ул. Городская вл. 6",
    coord: [55.492666, 37.321326],
    descr: "г. Москва, г.Троицк. ул. Городская вл. 6"
  },
  {
    title: "МО, Одинцовский р-он, ул. Триумфальная д.3",
    coord: [55.657398, 37.23569],
    descr: "МО, Одинцовский р-он, ул. Триумфальная д.3"
  },
  {
    title: "МО 143006  Одинцовский р-н, г. Одинцово, ул. Белорусская , д 5",
    coord: [55.663456, 37.303423],
    descr: "МО 143006  Одинцовский р-н, г. Одинцово, ул. Белорусская , д 5"
  },
  {
    title: "г. Москва, Мичуринский пр-кт 44А",
    coord: [55.694632, 37.491817],
    descr: "г. Москва, Мичуринский пр-кт 44А"
  },
  {
    title: "г.Москва, ул. Раменки, д. 3",
    coord: [55.693505, 37.495994],
    descr: "г.Москва, ул. Раменки, д. 3"
  },
  {
    title: "г.Москва, п.Внуковское, ул. Летчика Ульянина, дом. 5",
    coord: [55.625903, 37.307142],
    descr: "г.Москва, п.Внуковское, ул. Летчика Ульянина, дом. 5"
  },
  {
    title: "г.Москва, ул. Покрышкина, д. 5",
    coord: [55.664436, 37.469225],
    descr: "г.Москва, ул. Покрышкина, д. 5"
  },
  {
    title: "г.Москва, Солнцевский проспект, д. 21",
    coord: [55.647046, 37.41175],
    descr: "г.Москва, Солнцевский проспект, д. 21"
  },
  {
    title: "г. Москва, Мичуринский пр-кт 31к7",
    coord: [55.695682, 37.498402],
    descr: "г. Москва, Мичуринский пр-кт 31к7"
  },
  {
    title: "Киевское шоссе, 22-й километр, дв4с1кА, Бизнес-Парк Румянцево",
    coord: [55.634034, 37.444629],
    descr: "Киевское шоссе, 22-й километр, дв4с1кА, Бизнес-Парк Румянцево"
  },
  {
    title: "г.Москва, Новомосковский Административный округ, п.Коммунарка, ул. Александры Монаховой влад.30 стр.2",
    coord: [55.566435, 37.482978],
    descr: "г.Москва, Новомосковский Административный округ, п.Коммунарка, ул. Александры Монаховой влад.30 стр.2"
  },
  {
    title: "г.Москва Сосенское пос.ж/к Дубровка н/п ул.Сосновая д.6",
    coord: [55.571357, 37.445592],
    descr: "г.Москва Сосенское пос.ж/к Дубровка н/п ул.Сосновая д.6"
  },
  {
    title: "Москва, Можайское шоссе , д.31к.1",
    coord: [55.718593, 37.420401],
    descr: "Москва, Можайское шоссе , д.31к.1"
  },
  {
    title: "Москва, Рублевское шоссе, 52 А",
    coord: [55.755419, 37.402749],
    descr: "Москва, Рублевское шоссе, 52 А"
  },
  {
    title: "МО, Одинцовский р-он, 15 км., Рублево - Успенского ш., д.17",
    coord: [55.717612, 37.121013],
    descr: "МО, Одинцовский р-он, 15 км., Рублево - Успенского ш., д.17"
  },
  {
    title: "г. Одинцово, Можайское шоссе, д. 159",
    coord: [55.68667, 37.30583],
    descr: "г. Одинцово, Можайское шоссе, д. 159"
  },
  {
    title: "МО, Одинцовский р-н, п. ВНИИСОК, ул. Клиновая, д.1",
    coord: [55.659333, 37.199344],
    descr: "МО, Одинцовский р-н, п. ВНИИСОК, ул. Клиновая, д.1"
  },
  {
    title: "Москва г., Московский п, Московский г, Солнечная ул, зд.3",
    coord: [55.591498, 37.366062],
    descr: "Москва г., Московский п, Московский г, Солнечная ул, зд.3"
  },
  {
    title: "Москва, ул. Волочаевская 12а, стр.1",
    coord: [55.75593, 37.681982],
    descr: "Москва, ул. Волочаевская 12а, стр.1"
  },
  {
    title: "г.Москва, ул.  Череповецкая, д.17",
    coord: [55.898906, 37.58517],
    descr: "г.Москва, ул.  Череповецкая, д.17"
  },
  {
    title: "г.Москва, ул.Полярная д.21",
    coord: [55.87942, 37.634604],
    descr: "г.Москва, ул.Полярная д.21"
  },
  {
    title: "г.Москва, ул Лобненская, д. 4 А",
    coord: [55.889881, 37.537676],
    descr: "г.Москва, ул Лобненская, д. 4 А"
  },
  {
    title: "МО г. Химки ул. 9 мая д.8А",
    coord: [55.901571, 37.415496],
    descr: "МО г. Химки ул. 9 мая д.8А"
  },
  {
    title: "Ярославское шоссе, 12 к. 1",
    coord: [55.901571, 37.415496],
    descr: "Ярославское шоссе, 12 к. 1"
  },
  {
    title: "г.Москва, ул. Свободы, 44_Капитал",
    coord: [55.847826, 37.454654],
    descr: "г.Москва, ул. Свободы, 44_Капитал"
  },
  {
    title: "г.Москва, ул. Свободы 91 с1",
    coord: [55.866258, 37.445994],
    descr: "г.Москва, ул. Свободы 91 с1"
  },
  {
    title: "МО, г.о Химки, пос. Подрезково, кв. Кирилловка, влад. 55Г",
    coord: [55.959941, 37.336214],
    descr: "МО, г.о Химки, пос. Подрезково, кв. Кирилловка, влад. 55Г"
  },
  {
    title: "МО, г.Химки, ул. Молодежная, д. 2",
    coord: [55.878758, 37.423375],
    descr: "МО, г.Химки, ул. Молодежная, д. 2"
  },
  {
    title: "г.Москва,тер.Щербинка  ул. Брусилова , д. 29а",
    coord: [55.500264, 37.593569],
    descr: "г.Москва,тер.Щербинка  ул. Брусилова , д. 29а"
  },
  {
    title: "МО г.Подольск, пр-кт Октябрьский, 9В",
    coord: [55.426554, 37.504439],
    descr: "МО г.Подольск, пр-кт Октябрьский, 9В"
  },
  {
    title: "МО, г.Подольск, ул. Ленинградская, д.21",
    coord: [55.424235, 37.493371],
    descr: "МО, г.Подольск, ул. Ленинградская, д.21"
  },
  {
    title: "МО, г. Подольск, ул. Советская, 20/44",
    coord: [55.430135, 37.550091],
    descr: "МО, г. Подольск, ул. Советская, 20/44"
  },
  {
    title: "МО г. Подольск ул. Профсоюзная 1 «б» стр. 1",
    coord: [55.461814, 37.557538],
    descr: "МО г. Подольск ул. Профсоюзная 1 «б» стр. 1"
  },
  {
    title: "МО г.Подольск, ул. Юбилейная, д. 2",
    coord: [55.418742, 37.501672],
    descr: "МО г.Подольск, ул. Юбилейная, д. 2"
  },
  {
    title: "МО, г. Сергиев Посад, ул.Вознесенская, д. 32 А",
    coord: [56.303876, 38.133178],
    descr: "МО, г. Сергиев Посад, ул.Вознесенская, д. 32 А"
  },
  {
    title: "г.Москва, ул. Щербаковская, д.  7А",
    coord: [55.78276, 37.726592],
    descr: "г.Москва, ул. Щербаковская, д.  7А"
  },
  {
    title: "г. Москва, ул. Снежная, дом 26",
    coord: [55.854997, 37.653388],
    descr: "г. Москва, ул. Снежная, дом 26"
  },
  {
    title: "Ярославское шоссе, 12 к. 1",
    coord: [55.853567, 37.683949],
    descr: "Ярославское шоссе, 12 к. 1"
  },
  {
    title: "МО, г. Щелково, Пролетарский п-т, д. 10",
    coord: [55.923942, 38.001405],
    descr: "МО, г. Щелково, Пролетарский п-т, д. 10"
  },
  {
    title: "г.Москва , Береговой проезд д 5",
    coord: [55.755023, 37.509245],
    descr: "г.Москва , Береговой проезд д 5"
  },
  {
    title: "г. Москва, ул.  Шелепихинская набережная 34к2",
    coord: [55.763057, 37.508894],
    descr: "г. Москва, ул.  Шелепихинская набережная 34к2"
  },
  {
    title: "г. Москва, ул. Озерная , д. 35",
    coord: [55.669107, 37.448033],
    descr: "г. Москва, ул. Озерная , д. 35"
  },
  {
    title: "г. Москва, ул. Академика Анохина, д.58",
    coord: [55.650241, 37.469171],
    descr: "г. Москва, ул. Академика Анохина, д.58"
  },
  {
    title: "г.Москва, 2-я Филевская ул., д.14",
    coord: [55.739488, 37.491009],
    descr: "г.Москва, 2-я Филевская ул., д.14"
  },
  {
    title: "МО, г. Серпухов, МКР Ивановский дворик, Московское ш., д.55",
    coord: [54.942092, 37.40522],
    descr: "МО, г. Серпухов, МКР Ивановский дворик, Московское ш., д.55"
  },
  {
    title: "МО, с.Верзилово, ул.Петра Великого, стр.1",
    coord: [55.024394, 38.090598],
    descr: "МО, с.Верзилово, ул.Петра Великого, стр.1"
  },
  {
    title: "МО, г. Ступино, ул. Горького, д.26",
    coord: [54.891448, 38.062607],
    descr: "МО, г. Ступино, ул. Горького, д.26"
  },
  {
    title: "г. Москва, ул. Островитянова,  д.7",
    coord: [55.644328, 37.494836],
    descr: "г. Москва, ул. Островитянова,  д.7"
  },
  {
    title: "г.Москва, ул. Профсоюзная, д.61 А",
    coord: [55.656037, 37.541512],
    descr: "г.Москва, ул. Профсоюзная, д.61 А"
  },
  {
    title: "г. Москва, ул. Наметкина, 3",
    coord: [55.666056, 37.545824],
    descr: "г. Москва, ул. Наметкина, 3"
  },
  {
    title: "г. Москва, ул. Академика Варги 8, корп 1",
    coord: [55.630141, 37.474453],
    descr: "г. Москва, ул. Академика Варги 8, корп 1"
  },
  {
    title: "г.Москва, ул. Удальцова, д. 42",
    coord: [55.683752, 37.491072],
    descr: "г.Москва, ул. Удальцова, д. 42"
  },
  {
    title: "г.Москва, Ленинский проспект, д. 99",
    coord: [55.668635, 37.518767],
    descr: "г.Москва, Ленинский проспект, д. 99"
  },
  {
    title: "г. Москва ул 26 Бакинских комиссаров д 7, корп 6",
    coord: [55.655493, 37.484667],
    descr: "г. Москва ул 26 Бакинских комиссаров д 7, корп 6"
  },
  {
    title: "г. Москва, ул. Академика Капицы д.34/121",
    coord: [55.628535, 37.517617],
    descr: "г. Москва, ул. Академика Капицы д.34/121"
  },
  {
    title: "г.Москва, Боровское шоссе,  д.6",
    coord: [55.658799, 37.401914],
    descr: "г.Москва, Боровское шоссе,  д.6"
  },
  {
    title: "Москва, Боровское ш.,35",
    coord: [55.641204, 37.359801],
    descr: "Москва, Боровское ш.,35"
  },
  {
    title: "МО, Одинцовского района, пос. Горки-10 д.30 А",
    coord: [55.706386, 37.020965],
    descr: "МО, Одинцовского района, пос. Горки-10 д.30 А"
  },
  {
    title: "МО, Одинцовский р-он, деревня Солослово, КИЗ Горки-8, д. 275",
    coord: [55.706031, 37.160438],
    descr: "МО, Одинцовский р-он, деревня Солослово, КИЗ Горки-8, д. 275"
  },
  {
    title: "Московская обл, Одинцовский р-н, д.Лапино ,  ГП-3, стр. 25",
    coord: [55.682364, 37.143438],
    descr: "Московская обл, Одинцовский р-н, д.Лапино ,  ГП-3, стр. 25"
  },
  {
    title: "МО,  г. Одинцово, ул.Чистяковой д.3",
    coord: [55.694408, 37.33145],
    descr: "МО,  г. Одинцово, ул.Чистяковой д.3"
  },
  {
    title: "г. Москва, п. Московский, ул. Татьянин Парк, д. 18А",
    coord: [55.657370, 37.424360],
    descr: "г. Москва, п. Московский, ул. Татьянин Парк, д. 18А"
  },
  {
    title: "г.Москва,ул.Производственная д.12 корп 2",
    coord: [55.643058, 37.391107],
    descr: "г.Москва,ул.Производственная д.12 корп 2"
  },
  {
    title: "г.Москва, п.Первомайское, д.Рогозино, участок 20,лит.И",
    coord: [55.535761, 37.163255],
    descr: "г.Москва, п.Первомайское, д.Рогозино, участок 20,лит.И"
  },
  {
    title: "г.Москва, ул. Скульптора Мухиной, д.12",
    coord: [55.639761, 37.341601],
    descr: "г.Москва, ул. Скульптора Мухиной, д.12"
  },
  {
    title: "г.Москва, ул. Кировоградская, д.14",
    coord: [55.622609, 37.605939],
    descr: "г.Москва, ул. Кировоградская, д.14"
  },
  {
    title: "г. Москва Микрорайон Северное Чертаново, д.1А",
    coord: [55.637398, 37.600397],
    descr: "г. Москва Микрорайон Северное Чертаново, д.1А"
  },
  {
    title: "г.Москва, Кавказский бульвар, д.26",
    coord: [55.629232, 37.659578],
    descr: "г.Москва, Кавказский бульвар, д.26"
  },
  {
    title: "г.Москва, ул. Липецкая, д. 7а",
    coord: [55.583632, 37.682772],
    descr: "г.Москва, ул. Липецкая, д. 7а"
  },
  {
    title: "г.Москва, ул. Лебедянская, 14к1с2",
    coord: [55.586196, 37.672837],
    descr: "г.Москва, ул. Лебедянская, 14к1с2"
  },
  {
    title: "г.Москва, ул. Михневская д.4",
    coord: [55.586196, 37.672837],
    descr: "г.Москва, ул. Михневская д.4"
  },
  {
    title: "г.Москва, ул. Кантемировская 6, корп.1",
    coord: [55.637891, 37.67767],
    descr: "г.Москва, ул. Кантемировская 6, корп.1"
  },
  {
    title: "г.Москва, ул. Ялтинская, д.2",
    coord: [55.651364, 37.610628],
    descr: "г.Москва, ул. Ялтинская, д.2"
  },
  {
    title: "г.Москва, ул. Бирюлевская, д.21 к.1",
    coord: [55.594102, 37.664985],
    descr: "г.Москва, ул. Бирюлевская, д.21 к.1"
  },
  {
    title: "г.Москва, Чонгарский б-р, 16, 1",
    coord: [55.653766, 37.609901],
    descr: "г.Москва, Чонгарский б-р, 16, 1"
  },
  {
    title: "г. Москва, ул. Болотниковская, д.30",
    coord: [55.658352, 37.595618],
    descr: "г. Москва, ул. Болотниковская, д.30"
  },
  {
    title: "г.Москва  ул. Луганская  д. 5а",
    coord: [55.626091, 37.666279],
    descr: "г.Москва  ул. Луганская  д. 5а"
  },
  {
    title: "г. Москва, ул. Бакинская 17",
    coord: [55.620382, 37.657718],
    descr: "г. Москва, ул. Бакинская 17"
  },
  {
    title: "г.Москва ул.Кантемировская д.16.корп.1",
    coord: [55.620382, 37.657718],
    descr: "г.Москва ул.Кантемировская д.16.корп.1"
  },
  {
    title: "г.Москва, Габричевского д.10, к.3",
    coord: [55.815767, 37.462155],
    descr: "г.Москва, Габричевского д.10, к.3"
  },
  {
    title: "г.Москва, ул. Маршала Бирюзова, д. 32",
    coord: [55.799588, 37.483023],
    descr: "г.Москва, ул. Маршала Бирюзова, д. 32"
  },
  {
    title: "г.Москва, Хорошевское ш., д.27",
    coord: [55.777105, 37.523716],
    descr: "г.Москва, Хорошевское ш., д.27"
  },
  {
    title: "г.Москва, Сущевский Вал, д.46",
    coord: [55.792696, 37.612551],
    descr: "г.Москва, Сущевский Вал, д.46"
  },
  {
    title: "г.Москва, Кибальчича,д.12 к.2",
    coord: [55.815458, 37.653316],
    descr: "г.Москва, Кибальчича,д.12 к.2"
  },
  {
    title: "г.Москва, Шереметьевская 6, стр.1",
    coord: [55.795403, 37.617033],
    descr: "г.Москва, Шереметьевская 6, стр.1"
  },
  {
    title: "г. Москва, ул. Милашенкова д.4 а7",
    coord: [55.823757, 37.590970],
    descr: "г. Москва, ул. Милашенкова д.4 а7"
  },
  {
    title: "г.Москва ул.Космонавта Волкова 6а",
    coord: [55.815312, 37.512631],
    descr: "г.Москва ул.Космонавта Волкова 6а"
  },
  {
    title: "г.Москва, Столярный переулок, д.3/6",
    coord: [55.764794, 37.571597],
    descr: "г.Москва, Столярный переулок, д.3/6"
  },
  {
    title: "г.Москва, Ленинградский пр, д.31А, стр.1",
    coord: [55.78359, 37.56017],
    descr: "г.Москва, Ленинградский пр, д.31А, стр.1"
  },
  {
    title: "МО,Клинский р-н,Клин г,Карла Маркса ул,4",
    coord: [56.331872, 36.712861],
    descr: "МО,Клинский р-н,Клин г,Карла Маркса ул,4"
  },
  {
    title: "МО, г. Клин,  Советская площадь, д.5",
    coord: [56.333973, 36.734097],
    descr: "МО, г. Клин,  Советская площадь, д.5"
  },
  {
    title: "МО г. Солнечногорск ул. Красная 154",
    coord: [56.193907, 36.968746],
    descr: "МО г. Солнечногорск ул. Красная 154"
  },
  {
    title: "МО с/п Лучинское, д. Давыдовское",
    coord: [55.858397, 36.798532],
    descr: "МО с/п Лучинское, д. Давыдовское"
  },
  {
    title: "МО Солнечногорский р-н г. Солнечногорск ул Обуховская стр 44 А",
    coord: [56.179188, 36.955359],
    descr: "МО Солнечногорский р-н г. Солнечногорск ул Обуховская стр 44 А"
  },
  {
    title: "МО. Волоколамск, Панфилова,22",
    coord: [56.031186, 35.957917],
    descr: "МО. Волоколамск, Панфилова,22"
  },
  {
    title: "МО, Солнечногорский р-н, Искровский сельский округ, д. Чёрная грязь, стр. 2 А",
    coord: [55.975148, 37.31025],
    descr: "МО, Солнечногорский р-н, Искровский сельский округ, д. Чёрная грязь, стр. 2 А"
  },
  {
    title: "МО, Солнечногорский район, деревня Голиково, ул. МО, Горетовская, д.1",
    coord: [55.933391, 37.285465],
    descr: "МО, Солнечногорский район, деревня Голиково, ул. МО, Горетовская, д.1"
  },
  {
    title: "г.Москва, Удальцова ул., 85, кор. 5",
    coord: [55.680986, 37.485718],
    descr: "г.Москва, Удальцова ул., 85, кор. 5"
  },
  {
    title: "г.Москва, Новоясеневский проспект, д. 11",
    coord: [55.60667, 37.536284],
    descr: "г.Москва, Новоясеневский проспект, д. 11"
  },
  {
    title: "г.Москва, ул. Голубинская, д. 28",
    coord: [55.595094, 37.541539],
    descr: "г.Москва, ул. Голубинская, д. 28"
  },
  {
    title: "г. Москва ул. Ясногорская д. 2",
    coord: [55.610194, 37.536392],
    descr: "г. Москва ул. Ясногорская д. 2"
  },
  {
    title: "г.Москва ул Паустовского .6 корп 1",
    coord: [55.600323, 37.539069],
    descr: "г.Москва ул Паустовского .6 корп 1"
  },
  {
    title: "г.Москва Новоясеневский пр-т 7",
    coord: [55.607489, 37.532367],
    descr: "г.Москва Новоясеневский пр-т 7"
  },
  {
    title: "г.Москва, ул. Голубинская, д. 5, кор. 1",
    coord: [55.606894, 37.513233],
    descr: "г.Москва, ул. Голубинская, д. 5, кор. 1"
  },
  {
    title: "г.Москва, Кутузовский проспект дом 57 вл.3",
    coord: [55.727932, 37.476169],
    descr: "г.Москва, Кутузовский проспект дом 57 вл.3"
  },
  {
    title: "г.Москва, Славянский буль. д.9/1.",
    coord: [55.726249, 37.467536],
    descr: "г.Москва, Славянский буль. д.9/1."
  },
  {
    title: "г. Москва, ул. Матвеевская, д. 2.",
    coord: [55.705387, 37.47916],
    descr: "г. Москва, ул. Матвеевская, д. 2."
  },
  {
    title: "г.Москва, ул. Минская, д. 14",
    coord: [55.739225, 37.484442],
    descr: "г.Москва, ул. Минская, д. 14"
  },
  {
    title: "г.Москва, Свободный проспект, д. 33",
    coord: [55.752784, 37.819316],
    descr: "г.Москва, Свободный проспект, д. 33"
  },
  {
    title: "МО, г. Раменское,Ул. Вокзальная 4  Б",
    coord: [55.565809, 38.226657],
    descr: "МО, г. Раменское,Ул. Вокзальная 4  Б"
  },
  {
    title: "г.Раменское Донинское шоссе 16",
    coord: [55.588104, 38.251388],
    descr: "г.Раменское Донинское шоссе 16"
  },
  {
    title: "МО, г Жуковский  ул. Баженова  д 2а",
    coord: [55.604595, 38.082082],
    descr: "МО, г Жуковский  ул. Баженова  д 2а"
  },
  {
    title: "МО, г.Жуковский, ул.Гагарина,  д.65/7",
    coord: [55.607814, 38.092637],
    descr: "МО, г.Жуковский, ул.Гагарина,  д.65/7"
  },
  {
    title: "МО, г. Люберцы, Октябрьский проспект, дом 112",
    coord: [55.685132, 37.877536],
    descr: "МО, г. Люберцы, Октябрьский проспект, дом 112"
  },
  {
    title: "г.Москва, Россошанский пр., д 3",
    coord: [55.600918, 37.609272],
    descr: "г.Москва, Россошанский пр., д 3"
  },
  {
    title: "г.Москва, Варшавское шоссе д.26 стр 5,6,7,8",
    coord: [55.700877, 37.622405],
    descr: "г.Москва, Варшавское шоссе д.26 стр 5,6,7,8"
  },
  {
    title: "г.Москва, ул.Коломенская, д. 7",
    coord: [55.682128, 37.702885],
    descr: "г.Москва, ул.Коломенская, д. 7"
  },
  {
    title: "г.Москва, пр-кт Андропова, 22",
    coord: [55.682651, 37.661922],
    descr: "г.Москва, пр-кт Андропова, 22"
  },
  {
    title: "г. Москва, пр-кт Балаклавский, 16А",
    coord: [55.64221, 37.603666],
    descr: "г. Москва, пр-кт Балаклавский, 16А"
  },
  {
    title: "г. Москва, ул. Варшавское 152а",
    coord: [55.591604, 37.592837],
    descr: "г. Москва, ул. Варшавское 152а"
  },
  {
    title: "г.Москва, ул. Старокачаловская, д. 1 Б",
    coord: [55.568558, 37.585386],
    descr: "г.Москва, ул. Старокачаловская, д. 1 Б"
  },
  {
    title: "г.Москва, бульвар  Адмирала Ушакова д.7",
    coord: [55.546312, 37.551232],
    descr: "г.Москва, бульвар  Адмирала Ушакова д.7"
  },
  {
    title: "г.Москва, ул. Грина, д. 7",
    coord: [55.567102, 37.569764],
    descr: "г.Москва, ул. Грина, д. 7"
  },
  {
    title: "г.Москва, ул. Адмирала Лазарева, д. 24",
    coord: [55.546924, 37.532475],
    descr: "г.Москва, ул. Адмирала Лазарева, д. 24"
  },
  {
    title: "г.Москва, ул.Адмирала Лазарева, 52",
    coord: [55.542767, 37.518291],
    descr: "г.Москва, ул.Адмирала Лазарева, 52"
  },
  {
    title: "г. Москва, ул. Веневская, д. 6",
    coord: [55.54785, 37.543255],
    descr: "г. Москва, ул. Веневская, д. 6"
  },
  {
    title: "МО, г. Балашиха, ЦОВБ, дом 20, п.1",
    coord: [55.784501, 37.877958],
    descr: "МО, г. Балашиха, ЦОВБ, дом 20, п.1"
  },
  {
    title: "г.Москва, Новокосинская ул, 10, корп. 2",
    coord: [55.734283, 37.856668],
    descr: "г.Москва, Новокосинская ул, 10, корп. 2"
  },
  {
    title: "г. Москва, ул. Профсоюзная, д. 118",
    coord: [55.636311, 37.521138],
    descr: "г. Москва, ул. Профсоюзная, д. 118"
  },
  {
    title: "г.Москва ул. Введенского 13Б",
    coord: [55.642159, 37.542033],
    descr: "г.Москва ул. Введенского 13Б"
  },
  {
    title: "г.Москва,  пр-кт Вернадского 86а",
    coord: [55.663024, 37.481001],
    descr: "г.Москва,  пр-кт Вернадского 86а"
  },
  {
    title: "г. Москва, г. Троицк, Сиреневый б-р, 1",
    coord: [55.468117, 37.296497],
    descr: "г. Москва, г. Троицк, Сиреневый б-р, 1"
  },
  {
    title: "г. Москва, п. Марушкинское, вблизи д. Б. Свинорье",
    coord: [55.578891, 37.135046],
    descr: "г. Москва, п. Марушкинское, вблизи д. Б. Свинорье"
  },
  {
    title: "г.Москва, Лазоревый проезд, 5, к.5",
    coord: [55.847295, 37.635602],
    descr: "г.Москва, Лазоревый проезд, 5, к.5"
  },
  {
    title: "г.Москва. Ул.Мурановская, д.15а",
    coord: [55.893612, 37.600603],
    descr: "г.Москва. Ул.Мурановская, д.15а"
  },
  {
    title: "г.Москва, Проспект Мира, д. 33c1",
    coord: [55.780319, 37.632098],
    descr: "г.Москва, Проспект Мира, д. 33c1"
  },
  {
    title: "г.Москва, Тимирязевская 2/3",
    coord: [55.807921, 37.57351],
    descr: "г.Москва, Тимирязевская 2/3"
  },
  {
    title: "г. Москва, ул. Дубнинская, 40а",
    coord: [55.888856, 37.559317],
    descr: "г. Москва, ул. Дубнинская, 40а"
  },
  {
    title: "г.Москва, ул. Милашенкова, д. 8",
    coord: [55.825138, 37.585305],
    descr: "г.Москва, ул. Милашенкова, д. 8"
  },
  {
    title: "г.Москва, Керамический пр-зд, д. 51, кор.2.",
    coord: [55.875486, 37.564572],
    descr: "г.Москва, Керамический пр-зд, д. 51, кор.2."
  },
  {
    title: "МО, г. Подольск, ул. Свердлова, 26",
    coord: [55.424316, 37.538305],
    descr: "МО, г. Подольск, ул. Свердлова, 26"
  },
  {
    title: "МО г. Подольск. Красногвардейский бульвар д.44B",
    coord: [55.433295, 37.494571],
    descr: "МО г. Подольск. Красногвардейский бульвар д.44B"
  },
  {
    title: "МО, г. Подольск, ул. Машиностроителей, д. 22",
    coord: [55.408297, 37.571947],
    descr: "МО, г. Подольск, ул. Машиностроителей, д. 22"
  },
  {
    title: "МО.г.Чехов, ул Московская вл.96",
    coord: [55.153262, 37.459478],
    descr: "МО.г.Чехов, ул Московская вл.96"
  },
  {
    title: "Обнинск Киевское шоссе 21",
    coord: [55.102045, 36.638238],
    descr: "Обнинск Киевское шоссе 21"
  },
  {
    title: "МО, п.Совхоза им.Ленина, 5А",
    coord: [55.586654, 37.735683],
    descr: "МО, п.Совхоза им.Ленина, 5А"
  },
  {
    title: "МО г.Климовск ул.Симферопольская д.35",
    coord: [55.367965, 37.532888],
    descr: "МО г.Климовск ул.Симферопольская д.35"
  },
  {
    title: "г.Москва, Щербинка, Новостроевская, 6",
    coord: [55.504216, 37.559182],
    descr: "г.Москва, Щербинка, Новостроевская, 6"
  },
  {
    title: "г.Москва, ул. Веневская, д. 15",
    coord: [55.544275, 37.548627],
    descr: "г.Москва, ул. Веневская, д. 15"
  },
  {
    title: "г.Москва, Варшавское шоссе, д. 124, кор 1",
    coord: [55.627565, 37.615937],
    descr: "г.Москва, Варшавское шоссе, д. 124, кор 1"
  },
  {
    title: "г. Домодедово Каширское Шоссе 3А",
    coord: [55.451967, 37.763207],
    descr: "г. Домодедово Каширское Шоссе 3А"
  },
  {
    title: "г. Москва, Ленинский проспект, д.109",
    coord: [55.663842, 37.511445],
    descr: "г. Москва, Ленинский проспект, д.109"
  },
  {
    title: "г.Москва, ул. Миклухо-Маклая, д. 37",
    coord: [55.645476, 37.521318],
    descr: "г.Москва, ул. Миклухо-Маклая, д. 37"
  },
  {
    title: "г.Москва ул. Героев Панфиловцев 7",
    coord: [55.857144, 37.43207],
    descr: "г.Москва ул. Героев Панфиловцев 7"
  },
  {
    title: "г.Москва Ленинградское ш.112 к 4",
    coord: [55.865339, 37.465784],
    descr: "г.Москва Ленинградское ш.112 к 4"
  },
  {
    title: "г.Москва,  Ленинградский пр-т 37, Б",
    coord: [55.790221, 37.544638],
    descr: "г.Москва,  Ленинградский пр-т 37, Б"
  },
  {
    title: "г.Москва, Маршала Федоренко 12",
    coord: [55.881722, 37.488844],
    descr: "г.Москва, Маршала Федоренко 12"
  },
  {
    title: "г.Москва, ул. Онежская, д. 34, кор. 1",
    coord: [55.858468, 37.511463],
    descr: "г.Москва, ул. Онежская, д. 34, кор. 1"
  },
  {
    title: "г.Москва, ул. Онежская, 20",
    coord: [55.851763, 37.520114],
    descr: "г.Москва, ул. Онежская, 20"
  },
  {
    title: "г.Москва, ул.Фестивальная дом 2Б",
    coord: [55.855083, 37.478091],
    descr: "г.Москва, ул.Фестивальная дом 2Б"
  },
  {
    title: "г.Москва, ул. Зеленоградская, д. 33, корп. 2,_Капитал",
    coord: [55.875223, 37.490497],
    descr: "г.Москва, ул. Зеленоградская, д. 33, корп. 2,_Капитал"
  },
  {
    title: "г.Москва, ул.Воротынская 18",
    coord: [55.889967, 37.388394],
    descr: "г.Москва, ул.Воротынская 18"
  },
  {
    title: "г.Москва, Соколово-Мещерская 29",
    coord: [55.905396, 37.384819],
    descr: "г.Москва, Соколово-Мещерская 29"
  },
  {
    title: "г.Москва, Таллинская 7",
    coord: [55.800468, 37.396129],
    descr: "г.Москва, Таллинская 7"
  },
  {
    title: "г.Москва, Осенний бульвар, д. 12, кор. 1",
    coord: [55.758473, 37.409334],
    descr: "г.Москва, Осенний бульвар, д. 12, кор. 1"
  },
  {
    title: "г.Москва, ул. Нежинская, д. 6,  корп, 1",
    coord: [55.709596, 37.470716],
    descr: "г.Москва, ул. Нежинская, д. 6,  корп, 1"
  },
  {
    title: "г. Москва ул Маломосковская 20 стр 1",
    coord: [55.812509, 37.65125],
    descr: "г. Москва ул Маломосковская 20 стр 1"
  },
  {
    title: "г.Москва, Открытое ш., 9, стр. 1",
    coord: [55.815413, 37.738054],
    descr: "г.Москва, Открытое ш., 9, стр. 1"
  },
  {
    title: "Москва, Малыгина, д.7",
    coord: [55.880303, 37.694747],
    descr: "Москва, Малыгина, д.7"
  },
  {
    title: "г.Москва, Перовская ул., 61А",
    coord: [55.745341, 37.797343],
    descr: "г.Москва, Перовская ул., 61А"
  },
  {
    title: "123182, г.Москва, Щукинская ул. 42",
    coord: [55.809474, 37.464571],
    descr: "123182, г.Москва, Щукинская ул. 42"
  },
  {
    title: "г. Москва, ул. Перерва, дом 43, корп. 1",
    coord: [55.659653, 37.74967],
    descr: "г. Москва, ул. Перерва, дом 43, корп. 1"
  },
  {
    title: "г. Москва, Карамышевская набережная, 2А",
    coord: [55.769135, 37.494521],
    descr: "г. Москва, Карамышевская набережная, 2А"
  },
  {
    title: "109383, г.Москва, Шоссейная ул. 49",
    coord: [55.675123, 37.72369],
    descr: "109383, г.Москва, Шоссейная ул. 49"
  },
  {
    title: "г.Москва, Варшавское ш, 9, стр.1Б",
    coord: [55.700035, 37.62369],
    descr: "г.Москва, Варшавское ш, 9, стр.1Б"
  },
  {
    title: "г.Москва, Волгоградский пр-кт, 18, стр.1",
    coord: [55.728327, 37.677283],
    descr: "г.Москва, Волгоградский пр-кт, 18, стр.1"
  },
  {
    title: "г.Москва, Липецкая ул., 16/14, к.1",
    coord: [55.595715, 37.671274],
    descr: "г.Москва, Липецкая ул., 16/14, к.1"
  },
  {
    title: "г.Москва, ул. Шаболовка, д. 10",
    coord: [55.723465, 37.610269],
    descr: "г.Москва, ул. Шаболовка, д. 10"
  },
  {
    title: "г.Москва, 3-й Крутицкий пер., 18",
    coord: [55.731855, 37.664033],
    descr: "г.Москва, 3-й Крутицкий пер., 18"
  },
  {
    title: "г. Москва, ул. Гарибальди, д. 23",
    coord: [55.671443, 37.554026],
    descr: "г. Москва, ул. Гарибальди, д. 23"
  },
  {
    title: "г. Москва, ул. Гарибальди, д. 23",
    coord: [55.671443, 37.554026],
    descr: "г. Москва, ул. Гарибальди, д. 23"
  },
  {
    title: "г. Москва, ул. Академика Челомея, дом 3, корп. 2",
    coord: [55.659495, 37.527103],
    descr: "г. Москва, ул. Академика Челомея, дом 3, корп. 2"
  },
  {
    title: "г. Москва, Севастопольский пр-т 28, корп.2",
    coord: [55.66469, 37.578262],
    descr: "г. Москва, Севастопольский пр-т 28, корп.2"
  },
  {
    title: "г. Москва. Ул.Новочеремушкинская д.26 корп.1",
    coord: [55.680057, 37.575298],
    descr: "г. Москва. Ул.Новочеремушкинская д.26 корп.1"
  },
  {
    title: "г.Москва, ул. Андропова, д.8",
    coord: [55.695875, 37.664905],
    descr: "г.Москва, ул. Андропова, д.8"
  },
  {
    title: "г.Москва, ул. Б. Тульская, д.2",
    coord: [55.712344, 37.620577],
    descr: "г.Москва, ул. Б. Тульская, д.2"
  },
  {
    title: "г.Москва, Нагатинская, д. 16",
    coord: [55.681534, 37.652616],
    descr: "г.Москва, Нагатинская, д. 16"
  },
  {
    title: "г.Москва ул.Люсиновская д.70 стр.1",
    coord: [55.714891, 37.621714],
    descr: "г.Москва ул.Люсиновская д.70 стр.1"
  },
  {
    title: "г.Москва, пл. Киевского Вокзала, д. 2",
    coord: [55.744637, 37.566072],
    descr: "г.Москва, пл. Киевского Вокзала, д. 2"
  },
  {
    title: "г.Москва, Литовский бульвар,  д. 22",
    coord: [55.744637, 37.566072],
    descr: "г.Москва, Литовский бульвар,  д. 22"
  },
  {
    title: "г.Москва, Тишинская площадь, д. 1, стр.1",
    coord: [55.769231, 37.583373],
    descr: "г.Москва, Тишинская площадь, д. 1, стр.1"
  },
  {
    title: "г. Москва, Ленинградский пр-т, д.36",
    coord: [55.791248, 37.559388],
    descr: "г. Москва, Ленинградский пр-т, д.36"
  },
  {
    title: "г.Москва, Протопоповский переулок , д. 3",
    coord: [55.780704, 37.635072],
    descr: "г.Москва, Протопоповский переулок , д. 3"
  },
  {
    title: "г.Москва, Проспект Мира, д. 92 c2",
    coord: [55.793232, 37.636365],
    descr: "г.Москва, Проспект Мира, д. 92 c2"
  },
  {
    title: "г.Москва,Большая Новодмитровская д.23 стр.3",
    coord: [55.802958, 37.583742],
    descr: "г.Москва,Большая Новодмитровская д.23 стр.3"
  },
  {
    title: "г.Москва, ул. Новослободская, д.4",
    coord: [55.780036, 37.601403],
    descr: "г.Москва, ул. Новослободская, д.4"
  },
  {
    title: "г.Москва, Шмитовский проезд,  д 16, кор 2",
    coord: [55.758119, 37.546974],
    descr: "г.Москва, Шмитовский проезд,  д 16, кор 2"
  },
  {
    title: "г.Москва, ул. Большая Дорогомиловская д.8",
    coord: [55.746223, 37.565389],
    descr: "г.Москва, ул. Большая Дорогомиловская д.8"
  },
  {
    title: "г.Москва, ул.Тихвинская д.3 стр.1",
    coord: [55.785939, 37.600882],
    descr: "г.Москва, ул.Тихвинская д.3 стр.1"
  },
  {
    title: "г.Москва, ул.Ладожская д.13 стр.1",
    coord: [55.772087, 37.685099],
    descr: "г.Москва, ул.Ладожская д.13 стр.1"
  },
  {
    title: "г. Москва, ул. Стромынка д.25 стр 1",
    coord: [55.795666, 37.70072],
    descr: "г. Москва, ул. Стромынка д.25 стр 1"
  },
  {
    title: "г.Москва, ул. Коровий вал, д. 1",
    coord: [55.729331, 37.622612],
    descr: "г.Москва, ул. Коровий вал, д. 1"
  },
  {
    title: "г.Москва, ул. Театральная аллея, д3, стр.1",
    coord: [55.793227, 37.559883],
    descr: "г.Москва, ул. Театральная аллея, д3, стр.1"
  },
  {
    title: "г.Москва, Новопетровская ул., 6",
    coord: [55.825664, 37.51653],
    descr: "г.Москва, Новопетровская ул., 6"
  },
  {
    title: "МО, Видное, Березовая, 8",
    coord: [55.54072, 37.718327],
    descr: "МО, Видное, Березовая, 8"
  },
  {
    title: "МО, Видное, Радужная, 2",
    coord: [55.542966, 37.710162],
    descr: "МО, Видное, Радужная, 2"
  },
  {
    title: "г.Москва, ул.Марксистская, 1",
    coord: [55.740517, 37.658616],
    descr: "г.Москва, ул.Марксистская, 1"
  },
  {
    title: "г.Москва, ул. Кустанайская, д. 6",
    coord: [55.619574, 37.752158],
    descr: "г.Москва, ул. Кустанайская, д. 6"
  },
  {
    title: "г.Москва, ул. Домодедовская, д. 28",
    coord: [55.604758, 37.712345],
    descr: "г.Москва, ул. Домодедовская, д. 28"
  },
  {
    title: "г.Москва, Вешняковская ул., 22, А",
    coord: [55.720403, 37.822137],
    descr: "г.Москва, Вешняковская ул., 22, А"
  },
  {
    title: "г.Москва, ул.Елецкая, д.15",
    coord: [55.607356, 37.733716],
    descr: "г.Москва, ул.Елецкая, д.15"
  },
  {
    title: "г.Москва ул. Шипиловская 50 к1",
    coord: [55.621231, 37.73818],
    descr: "г.Москва ул. Шипиловская 50 к1"
  },
  {
    title: "г.Москва, Мусы Джалиля, 6,к2",
    coord: [55.628047, 37.740929],
    descr: "г.Москва, Мусы Джалиля, 6,к2"
  },
  {
    title: "г. Москва, Борисовский проезд, 3к1",
    coord: [55.625328, 37.714599],
    descr: "г. Москва, Борисовский проезд, 3к1"
  },
  {
    title: "г. Москва, ул. Борисовские пруды, д.10, корп. 1",
    coord: [55.635467, 37.739752],
    descr: "г. Москва, ул. Борисовские пруды, д.10, корп. 1"
  },
  {
    title: "г. Москва, Пролетарский пр-т, 19, кор. 1",
    coord: [55.641229, 37.656173],
    descr: "г. Москва, Пролетарский пр-т, 19, кор. 1"
  },
  {
    title: "г.Москва, Ореховый б-р д.14 к.3",
    coord: [55.60968, 37.720106],
    descr: "г.Москва, Ореховый б-р д.14 к.3"
  },
  {
    title: "г.Москва, ул.Волгоградский  проспект 1, стр.1",
    coord: [55.733462, 37.671112],
    descr: "г.Москва, ул.Волгоградский  проспект 1, стр.1"
  },
  {
    title: "г.Москва, Мячковский б-р, 18, кор. 1",
    coord: [55.649921, 37.758823],
    descr: "г.Москва, Мячковский б-р, 18, кор. 1"
  },
  {
    title: "г.Москва, ул.Совхозная, д.8",
    coord: [55.670615, 37.747262],
    descr: "г.Москва, ул.Совхозная, д.8"
  },
  {
    title: "г.Москва, Новочеркасский бульвар, дом 20, корп. 5",
    coord: [55.645781, 37.718166],
    descr: "г.Москва, Новочеркасский бульвар, дом 20, корп. 5"
  },
  {
    title: "г. Москва, ул. Паперника, дом 9",
    coord: [55.720859, 37.787084],
    descr: "г. Москва, ул. Паперника, дом 9"
  },
  {
    title: "г.Москва, ул.Братиславская, д.12",
    coord: [55.659744, 37.752993],
    descr: "г.Москва, ул.Братиславская, д.12"
  },
  {
    title: "Москва, ул. Люблинская, 102А",
    coord: [55.652314, 37.742232],
    descr: "Москва, ул. Люблинская, 102А"
  },
  {
    title: "МО.гИвантеевка ул.Советская проспект 2А",
    coord: [55.975254, 37.906902],
    descr: "МО.гИвантеевка ул.Советская проспект 2А"
  },
  {
    title: "МО,сп.Федоскинскинское ,п.Птицефабрики дом 50",
    coord: [55.993716, 37.546004],
    descr: "МО,сп.Федоскинскинское ,п.Птицефабрики дом 50"
  },
  {
    title: "г. Можайск, МО, ул. Академика Павлова, д. 9",
    coord: [55.499836, 36.031022],
    descr: "г. Можайск, МО, ул. Академика Павлова, д. 9"
  },
  {
    title: "МО, г. Серпухов, Борисовское ш., д.1",
    coord: [54.91752, 37.426501],
    descr: "МО, г. Серпухов, Борисовское ш., д.1"
  },
  {
    title: "МО г. Протвино, ул. Ленина, д. 22",
    coord: [54.873434, 37.220589],
    descr: "МО г. Протвино, ул. Ленина, д. 22"
  },
  {
    title: "МО., Одинцовский р-н, ул. Неделина, д.6",
    coord: [55.678448, 37.268074],
    descr: "МО., Одинцовский р-н, ул. Неделина, д.6"
  },
  {
    title: "г.Калуга,  ул.Суворова,  д.113",
    coord: [54.517044, 36.25605],
    descr: "г.Калуга,  ул.Суворова,  д.113"
  },
  {
    title: "г. Калуга, ул .Пролетарская 108",
    coord: [54.518418, 36.264844],
    descr: "г. Калуга, ул .Пролетарская 108"
  },
  {
    title: "МО г.Дубна пр-кт Боголюбова д.24А",
    coord: [56.735851, 37.157015],
    descr: "МО г.Дубна пр-кт Боголюбова д.24А"
  },
  {
    title: "МО, г.Дубна, пр-т Боголюбова,  д. 13",
    coord: [56.738394, 37.168496],
    descr: "МО, г.Дубна, пр-т Боголюбова,  д. 13"
  },
  {
    title: "МО, г.Ногинск, ул.3-го Интернационала,  д.62",
    coord: [55.855906, 38.441471],
    descr: "МО, г.Ногинск, ул.3-го Интернационала,  д.62"
  },
  {
    title: "МО, г. Орехово-Зуево, ул. Ленина, д.78",
    coord: [55.807997, 38.987395],
    descr: "МО, г. Орехово-Зуево, ул. Ленина, д.78"
  },
  {
    title: "МО, г.Электросталь  пр-т Ленина 010",
    coord: [55.81299, 38.430269],
    descr: "МО, г.Электросталь  пр-т Ленина 010"
  },
  {
    title: "МО, г. Наро-Фоминск, 73 км Киевского ш., д. 3, пом.1",
    coord: [55.366603, 36.758441],
    descr: "МО, г. Наро-Фоминск, 73 км Киевского ш., д. 3, пом.1"
  },
  {
    title: "МО, г. Коломна, ул.Советская пл., д.8",
    coord: [55.095678, 38.763984],
    descr: "МО, г. Коломна, ул.Советская пл., д.8"
  },
  {
    title: "МО г.Коломна площадь Восстания д.7",
    coord: [55.084132, 38.804948],
    descr: "МО г.Коломна площадь Восстания д.7"
  },
  {
    title: "МО, г.Королёв, пр-т Космонавтов,  д.41/1",
    coord: [55.907945, 37.867358],
    descr: "МО, г.Королёв, пр-т Космонавтов,  д.41/1"
  },
  {
    title: "г.Пушкино ул. Институтская стр.29",
    coord: [56.019309, 37.861447],
    descr: "г.Пушкино ул. Институтская стр.29"
  },
  {
    title: "МО, г.Пушкино Московский пр-т д 7а",
    coord: [56.011706, 37.847469],
    descr: "МО, г.Пушкино Московский пр-т д 7а"
  },
  {
    title: "МО, Королев,  ул Лесная 12 (КОВЧЕГ)",
    coord: [55.933953, 37.843202],
    descr: "МО, Королев,  ул Лесная 12 (КОВЧЕГ)"
  },
  {
    title: "МО. г.Королев, ул.Горького, д.79. к.13",
    coord: [55.918348, 37.883195],
    descr: "МО. г.Королев, ул.Горького, д.79. к.13"
  },
  {
    title: "г.Королев, мкр Юбилейный, ул.Тихонравова, д.35, к.7",
    coord: [55.937709, 37.851862],
    descr: "г.Королев, мкр Юбилейный, ул.Тихонравова, д.35, к.7"
  },
  {
    title: "МО, г.Королёв, пр-т Королева 6Г",
    coord: [55.920547, 37.83801],
    descr: "МО, г.Королёв, пр-т Королева 6Г"
  },
  {
    title: "МО, г.Королёв, пр-т Космонавтов,  д.12 А",
    coord: [55.917364, 37.867169],
    descr: "МО, г.Королёв, пр-т Космонавтов,  д.12 А"
  },
  {
    title: "МО, г.Королев М.О. Калининградская 5",
    coord: [55.913321, 37.850009],
    descr: "МО, г.Королев М.О. Калининградская 5"
  },
  {
    title: "Московская обл., г.Одинцово, Маршала Крылова б-р",
    coord: [55.6875962049401, 37.29920883467097],
    descr: "Московская обл., г.Одинцово, Маршала Крылова б-р"
  },
  {
    title: "109044, г.Москва, 3-й Крутицкий пер., 18",
    coord: [55.731855, 37.664033],
    descr: "109044, г.Москва, 3-й Крутицкий пер., 18"
  },
  {
    title: "Ул. Космонавтов д.15",
    coord: [55.821735, 37.660269],
    descr: "Ул. Космонавтов д.15"
  },
  {
    title: "г.Москва, ул.Земляной вал, д.33",
    coord: [55.757339, 37.659173],
    descr: "г.Москва, ул.Земляной вал, д.33"
  },
  {
    title: "г. Москва ул. Усачева 2, стр 1",
    coord: [55.730847, 37.576789],
    descr: "г. Москва ул. Усачева 2, стр 1"
  },
  {
    title: "г.Москва, Мичуринский пр-кт, ул. Олимпийская деревня, д.3 корп.1",
    coord: [55.676661, 37.467490],
    descr: "г.Москва, Мичуринский пр-кт, ул. Олимпийская деревня, д.3 корп.1"
  },
  {
    title: "г.Москва, Кутузовский проспект, д. 88",
    coord: [55.725595, 37.449677],
    descr: "г.Москва, Кутузовский проспект, д. 88"
  },
  {
    title: "г.Москва, Профсоюзная 129а",
    coord: [55.61813, 37.507484],
    descr: "г.Москва, Профсоюзная 129а"
  },
  {
    title: "г.Москва Кронштадтский бульвар 3",
    coord: [55.840897, 37.48543],
    descr: "г.Москва Кронштадтский бульвар 3"
  },
  {
    title: "г.Москва, Пресненская наб. д.2",
    coord: [55.749162, 37.539742],
    descr: "г.Москва, Пресненская наб. д.2"
  },
  {
    title: "109029, г.Москва, Средняя Калитниковская ул.28/4",
    coord: [55.730912, 37.697621],
    descr: "109029, г.Москва, Средняя Калитниковская ул.28/4"
  },
  {
    title: "г.Москва, Яблочкова ул., 19",
    coord: [55.818306, 37.580526],
    descr: "г.Москва, Яблочкова ул., 19"
  },
  {
    title: "г.Москва, Боровское шоссе, д.46",
    coord: [55.636524, 37.348401],
    descr: "г.Москва, Боровское шоссе, д.46"
  },
  {
    title: "г.Москва, Академика Скрябина ул, 30, к.1",
    coord: [55.703231, 37.792331],
    descr: "г.Москва, Академика Скрябина ул, 30, к.1"
  },
  {
    title: "142207, г.Серпухов, Борисовское ш, 17-А",
    coord: [54.91543, 37.43596],
    descr: "142207, г.Серпухов, Борисовское ш, 17-А"
  },
  {
    title: "109652, г.Москва, Мячковский б-р 18, к.1",
    coord: [55.649921, 37.758823],
    descr: "109652, г.Москва, Мячковский б-р 18, к.1"
  },
  {
    title: "127238, г.Москва, Дмитровское ш.80, с.1",
    coord: [55.864177, 37.551241],
    descr: "127238, г.Москва, Дмитровское ш.80, с.1"
  },
  {
    title: "129344, Москва, ул. Лётчика Бабушкина, 15",
    coord: [55.86355, 37.67343],
    descr: "129344, Москва, ул. Лётчика Бабушкина, 15"
  },
  {
    title: "119530, г.Москва, Аминьевское ш. 15",
    coord: [55.706401, 37.453971],
    descr: "119530, г.Москва, Аминьевское ш. 15"
  },
  {
    title: "140404, г.Коломна, 800-летия Коломны б-р, д.14",
    coord: [55.059075, 38.751633],
    descr: "140404, г.Коломна, 800-летия Коломны б-р, д.14"
  },
  {
    title: "111395, г.Москва, Вешняковская ул., д.22/а",
    coord: [55.720403, 37.822137],
    descr: "111395, г.Москва, Вешняковская ул., д.22/а"
  },
  {
    title: "249030, г.Обнинск, Маркса пр-т, у.71",
    coord: [55.12012, 36.601254],
    descr: "249030, г.Обнинск, Маркса пр-т, у.71"
  },
  {
    title: "111394, г.Москва, ул.Перовская, д.61А",
    coord: [55.745341, 37.797343],
    descr: "111394, г.Москва, ул.Перовская, д.61А"
  },
  {
    title: "г.Москва, ул.Скобелевская, д.24",
    coord: [55.545411, 37.55611],
    descr: "г.Москва, ул.Скобелевская, д.24"
  },
  {
    title: "Ростов-на-дону, пр. Сельмаш 2",
    coord: [47.244497, 39.765669],
    descr: "Ростов-на-дону, пр. Сельмаш 2"
  },
  {
    title: "Ростов-на-дону, пр. Космонавтов, 19А",
    coord: [47.288089, 39.714662],
    descr: "Ростов-на-дону, пр. Космонавтов, 19А"
  },
  {
    title: "г.Ростов-на-Дону ,пр. Будённовский,49",
    coord: [47.224936, 39.704673],
    descr: "г.Ростов-на-Дону ,пр. Будённовский,49"
  },
  {
    title: "г. Ростов-на-Дону, пр.Стачки,25",
    coord: [47.210608, 39.672361],
    descr: "г. Ростов-на-Дону, пр.Стачки,25"
  },
  {
    title: "г.Ростов-на-Дону , ул. Береговая 6",
    coord: [47.212555, 39.703766],
    descr: "г.Ростов-на-Дону , ул. Береговая 6"
  },
  {
    title: "РО г. Ростов-на-Дону, ул. Омская 2б",
    coord: [47.260473, 39.720735],
    descr: "РО г. Ростов-на-Дону, ул. Омская 2б"
  },
  {
    title: "РО, г. Ростов-на-Дону, ул.Текучева, д.139А",
    coord: [47.235075, 39.705473],
    descr: "РО, г. Ростов-на-Дону, ул.Текучева, д.139А"
  },
  {
    title: "Башкортостан, г. Уфа, Янаби д.36",
    coord: [54.785366, 56.123191],
    descr: "Башкортостан, г. Уфа, Янаби д.36"
  },
  {
    title: "Башкортостан, г. Уфа, Революционная, 52",
    coord: [54.73417, 55.958907],
    descr: "Башкортостан, г. Уфа, Революционная, 52"
  },
  {
    title: "Самарская обл., г. Самара, ул. Мичурина, 138",
    coord: [53.217014, 50.167603],
    descr: "Самарская обл., г. Самара, ул. Мичурина, 138"
  },
  {
    title: "Самарская обл., г. Самара, ул. Молодогвардейская 209",
    coord: [53.204778, 50.117782],
    descr: "Самарская обл., г. Самара, ул. Молодогвардейская 209"
  },
  {
    title: "Оренбургская обл., г. Оренбург, ул. Инверторная, д.37",
    coord: [51.818283, 55.172809],
    descr: "Оренбургская обл., г. Оренбург, ул. Инверторная, д.37"
  },
  {
    title: "г.Волжский , б-р Профсоюзов 1Б",
    coord: [48.776219, 44.773794],
    descr: "г.Волжский , б-р Профсоюзов 1Б"
  },
  {
    title: "г.Волжский , пр-т Ленина 100",
    coord: [48.777982, 44.757472],
    descr: "г.Волжский , пр-т Ленина 100"
  },
  {
    title: "г.Волгоград ул.Рокоссовского д.51",
    coord: [48.719801, 44.506618],
    descr: "г.Волгоград ул.Рокоссовского д.51"
  },
  {
    title: "г. Ростов-на-Дону, ул. Зорге, 33",
    coord: [47.229281, 39.628532],
    descr: "г. Ростов-на-Дону, ул. Зорге, 33"
  },
  {
    title: "г. Ростов-на-Дону, пр. Космонавтов 2/2",
    coord: [47.281219, 39.717555],
    descr: "г. Ростов-на-Дону, пр. Космонавтов 2/2"
  },
  {
    title: "Ростов-на-дону, пр. Королева 20а",
    coord: [47.294708, 39.711312],
    descr: "Ростов-на-дону, пр. Королева 20а"
  },
  {
    title: "Башкортостан, г. Уфа, ул. Степана Кувыкина, 18",
    coord: [54.707686, 55.999789],
    descr: "Башкортостан, г. Уфа, ул. Степана Кувыкина, 18"
  },
  {
    title: "Башкортостан, г. Уфа, пр Октября 107А",
    coord: [54.782744, 56.03176],
    descr: "Башкортостан, г. Уфа, пр Октября 107А"
  },
  {
    title: "Башкортостан, г. Уфа, ул. 50лет Октября, 2",
    coord: [54.734918, 55.960569],
    descr: "Башкортостан, г. Уфа, ул. 50лет Октября, 2"
  },
  {
    title: "Самарская обл., г. Самара, ул.Рабочая 15/ул Самарская, д 130",
    coord: [53.19413, 50.105853],
    descr: "Самарская обл., г. Самара, ул.Рабочая 15/ул Самарская, д 130"
  },
  {
    title: "Спб, Щербакова 7 кор 1 лит A",
    coord: [60.029247, 30.298189],
    descr: "Спб, Щербакова 7 кор 1 лит A"
  },
  {
    title: "Спб,Планерная 49",
    coord: [60.017881, 30.228875],
    descr: "Спб,Планерная 49"
  },
  {
    title: "СПб, Колпино, б-р Трудящихся, д.12, лит.А",
    coord: [59.737373, 30.572095],
    descr: "СПб, Колпино, б-р Трудящихся, д.12, лит.А"
  },
  {
    title: "Татарстан, г.Казань, пр. Победы, 50Б",
    coord: [55.748316, 49.206486],
    descr: "Татарстан, г.Казань, пр. Победы, 50Б"
  },
  {
    title: "СПб, г.Колпино, Тверская ул., д. 36/9, лит. А",
    coord: [59.740538, 30.611333],
    descr: "СПб, г.Колпино, Тверская ул., д. 36/9, лит. А"
  },
  {
    title: "СПб, г.Колпино, Тверская ул., д. 58/6, лит. А",
    coord: [59.735042, 30.612438],
    descr: "СПб, г.Колпино, Тверская ул., д. 58/6, лит. А"
  },
  {
    title: "пос.Шушары, ЖК Славянка, Колпинское шоссе д.77 лит А",
    coord: [59.732425, 30.469803],
    descr: "пос.Шушары, ЖК Славянка, Колпинское шоссе д.77 лит А"
  },
  {
    title: "Вологодская обл., г. Вологда,  ул. Лермонтова, д. 4",
    coord: [59.221533, 39.891999],
    descr: "Вологодская обл., г. Вологда,  ул. Лермонтова, д. 4"
  },
  {
    title: "г. Орел, ул. Октябрьская 122",
    coord: [52.98513, 36.073853],
    descr: "г. Орел, ул. Октябрьская 122"
  },
  {
    title: "г. Смоленск, Краснинское шоссе, д. 6Д",
    coord: [54.768936, 32.002248],
    descr: "г. Смоленск, Краснинское шоссе, д. 6Д"
  },
  {
    title: "НН Казанское шоссе, 4а",
    coord: [56.294596, 44.07725],
    descr: "НН Казанское шоссе, 4а"
  },
  {
    title: "Нижний Новгород, пр-т Гагарина, 29",
    coord: [56.293187, 43.977806],
    descr: "Нижний Новгород, пр-т Гагарина, 29"
  },
  {
    title: "г. Дзержинск, пр Циолковского, д 76А",
    coord: [56.228651, 43.399174],
    descr: "г. Дзержинск, пр Циолковского, д 76А"
  },
  {
    title: "г. Нижний Новгород, ул. Бурнаковская, д. 105",
    coord: [56.3429, 43.905788],
    descr: "г. Нижний Новгород, ул. Бурнаковская, д. 105"
  },
  {
    title: "г. Воронеж, Бульвар Победы, д. 23Б",
    coord: [51.710872, 39.159638],
    descr: "г. Воронеж, Бульвар Победы, д. 23Б"
  },
  {
    title: "г. Тула, Советская Улица, д. 10",
    coord: [54.194803, 37.611473],
    descr: "г. Тула, Советская Улица, д. 10"
  },
  {
    title: "г.Воронеж, ул. Средне-Московская, 32б",
    coord: [51.66897, 39.196379],
    descr: "г.Воронеж, ул. Средне-Московская, 32б"
  },
  {
    title: "г.Тула, ул. Лейтейзена , д.18.",
    coord: [54.191463, 37.601564],
    descr: "г.Тула, ул. Лейтейзена , д.18."
  },
  {
    title: "г.Воронеж ул. Героев Сибиряков 65а",
    coord: [51.646068, 39.138779],
    descr: "г.Воронеж ул. Героев Сибиряков 65а"
  },
  {
    title: "НН Гагарина, 228",
    coord: [56.228205, 43.945269],
    descr: "НН Гагарина, 228"
  },
  {
    title: "Н.Н. ул. Карла Маркса 7а",
    coord: [56.344017, 43.927078],
    descr: "Н.Н. ул. Карла Маркса 7а"
  },
  {
    title: "г. Орел, ул.Ливенская, 68А",
    coord: [52.950501, 36.110433],
    descr: "г. Орел, ул.Ливенская, 68А"
  },
  {
    title: "г Липецк ул. Терешковой 35 б",
    coord: [52.611237, 39.574498],
    descr: "г Липецк ул. Терешковой 35 б"
  },
  {
    title: "г.Воронеж, ул. 20-летия Октября, 90",
    coord: [51.655987, 39.188861],
    descr: "г.Воронеж, ул. 20-летия Октября, 90"
  },
  {
    title: "Нижний Новгород, пр-т Ленина, 33",
    coord: [56.287337, 43.928219],
    descr: "Нижний Новгород, пр-т Ленина, 33"
  },
  {
    title: "Н Новгород Революции 9",
    coord: [56.320338, 43.947623],
    descr: "Н Новгород Революции 9"
  },
  {
    title: "Г. Нижний Новгород, ул. Большая покровская, д. 82",
    coord: [56.308975, 43.987292],
    descr: "Г. Нижний Новгород, ул. Большая покровская, д. 82"
  },
  {
    title: "Нижний Новгород, пр-т Молодежный, 33",
    coord: [56.242434, 43.847353],
    descr: "Нижний Новгород, пр-т Молодежный, 33"
  },
  {
    title: "г. Воронеж  ул. Генерала  Лизюкова 60",
    coord: [51.706128, 39.149613],
    descr: "г. Воронеж  ул. Генерала  Лизюкова 60"
  },
  {
    title: "г. Воронеж,  Пр. Ленинский 1Д",
    coord: [51.633469, 39.230614],
    descr: "г. Воронеж,  Пр. Ленинский 1Д"
  },
  {
    title: "г. Воронеж, Бульвар Олимпийский, строение 10",
    coord: [51.712345, 39.201527],
    descr: "г. Воронеж, Бульвар Олимпийский, строение 10"
  },
  {
    title: "г. Рязань ул. Ленина 21",
    coord: [54.623993, 39.75152],
    descr: "г. Рязань ул. Ленина 21"
  },
  {
    title: "г. Рязань, ул.Соборная, д.15 А",
    coord: [54.630201, 39.739833],
    descr: "г. Рязань, ул.Соборная, д.15 А"
  },
  {
    title: "г.Рязань ул.Чкалова, д.18",
    coord: [54.626996, 39.702616],
    descr: "г.Рязань ул.Чкалова, д.18"
  },
  {
    title: "г.Тула ул. Ложевая  д. 122",
    coord: [54.201797, 37.64259],
    descr: "г.Тула ул. Ложевая  д. 122"
  },
  {
    title: "г.Тула Калужское шоссе д,1а",
    coord: [54.155815, 37.583293],
    descr: "г.Тула Калужское шоссе д,1а"
  },
  {
    title: "г. Липецк, ул. Осканова, 1",
    coord: [52.597001, 39.489374],
    descr: "г. Липецк, ул. Осканова, 1"
  },
  {
    title: "г.Липецк ул. Героя России Эдуарда Белана, д.10А",
    coord: [52.581704, 39.511967],
    descr: "г.Липецк ул. Героя России Эдуарда Белана, д.10А"
  },
  {
    title: "г.Брянск ул. Дуки 63",
    coord: [53.265671, 34.358637],
    descr: "г.Брянск ул. Дуки 63"
  },
  {
    title: "Н.Новгород Советская, 12",
    coord: [56.325609, 43.957971],
    descr: "Н.Новгород Советская, 12"
  },
  {
    title: "г. Дзержинск, пр Циолковского, д 49",
    coord: [56.229616, 43.424399],
    descr: "г. Дзержинск, пр Циолковского, д 49"
  },
  {
    title: "г. Нижний Новгород, ул. Веденяпина, 2Б",
    coord: [56.239508, 43.863936],
    descr: "г. Нижний Новгород, ул. Веденяпина, 2Б"
  },
  {
    title: "Сормовское ш д.1Д г Н.Новгород",
    coord: [56.329163, 43.907621],
    descr: "Сормовское ш д.1Д г Н.Новгород"
  },
  {
    title: "г. Нижний Новгород, ул. Мещерский бульвар, д. 10Б",
    coord: [56.339208, 43.935693],
    descr: "г. Нижний Новгород, ул. Мещерский бульвар, д. 10Б"
  },
  {
    title: "398046 Россия, Липецкая обл., г. Липецк, ул. Космонавтов, д. 96",
    coord: [52.60887, 39.546677],
    descr: "398046 Россия, Липецкая обл., г. Липецк, ул. Космонавтов, д. 96"
  },
  {
    title: "г. Рязань ул. Олимпийский городок д.1А",
    coord: [54.601733, 39.790552],
    descr: "г. Рязань ул. Олимпийский городок д.1А"
  },
  {
    title: "НН Чаадаева, 5д",
    coord: [56.329951, 43.856453],
    descr: "НН Чаадаева, 5д"
  },
  {
    title: "г.Сочи, ул.Набережная Лаванда 2, Красная Поляна",
    coord: [43.672903, 40.290725],
    descr: "г.Сочи, ул.Набережная Лаванда 2, Красная Поляна"
  },
  {
    title: "Башкортостан, г. Уфа, Менделеева , д.130",
    coord: [54.714235, 56.001262],
    descr: "Башкортостан, г. Уфа, Менделеева , д.130"
  },
  {
    title: "г. Екатеринбург ул. Степана Разина, 107",
    coord: [56.804949, 60.615072],
    descr: "г. Екатеринбург ул. Степана Разина, 107"
  },
  {
    title: "г. Екатеринбург, ул. Братская, д.27, к.3",
    coord: [56.776624, 60.596373],
    descr: "г. Екатеринбург, ул. Братская, д.27, к.3"
  },
  {
    title: "г.Пермь, ул. Юрша, 84",
    coord: [58.001976, 56.30509],
    descr: "г.Пермь, ул. Юрша, 84"
  },
  {
    title: "г. Пермь ул. Уинская, 15а",
    coord: [58.006154, 56.309079],
    descr: "г. Пермь ул. Уинская, 15а"
  },
  {
    title: "ХМАО, г. Сургут, ул. Профсоюзов 11",
    coord: [61.26934, 73.382145],
    descr: "ХМАО, г. Сургут, ул. Профсоюзов 11"
  },
  {
    title: "г. Тюмень, ул. 50 лет Октября, д. 14",
    coord: [57.152384, 65.567152],
    descr: "г. Тюмень, ул. 50 лет Октября, д. 14"
  },
  {
    title: "г.Тюмень ул. Ямская, 118",
    coord: [57.159638, 65.482486],
    descr: "г.Тюмень ул. Ямская, 118"
  },
  {
    title: "г. Магнитогорск ул. Грязнова, 26",
    coord: [53.39699, 58.975396],
    descr: "г. Магнитогорск ул. Грязнова, 26"
  },
  {
    title: "г. Челябинск, 40-летия Победы, д.1",
    coord: [55.191778, 61.281515],
    descr: "г. Челябинск, 40-летия Победы, д.1"
  },
  {
    title: "г.Пермь, ул. Уральская, 85",
    coord: [58.026581, 56.294706],
    descr: "г.Пермь, ул. Уральская, 85"
  },
  {
    title: "г.Пермь, Шоссе Космонавтов, 65",
    coord: [57.993262, 56.209231],
    descr: "г.Пермь, Шоссе Космонавтов, 65"
  },
  {
    title: "ХМАО, г.Сургут, ул 30 лет Победы, 46",
    coord: [61.253944, 73.43343],
    descr: "ХМАО, г.Сургут, ул 30 лет Победы, 46"
  },
  {
    title: "ХМАО, г.Ханты-Мансийск, ул. Заводская, 26",
    coord: [60.965884, 69.038332],
    descr: "ХМАО, г.Ханты-Мансийск, ул. Заводская, 26"
  },
  {
    title: "г. Тюмень, ул. Пермякова, 50б",
    coord: [57.118657, 65.577249],
    descr: "г. Тюмень, ул. Пермякова, 50б"
  },
  {
    title: "г.Тюмень ул. Герцена, 94",
    coord: [57.146051, 65.541954],
    descr: "г.Тюмень ул. Герцена, 94"
  },
  {
    title: "г.Тюмень ул. Московский тракт, 118",
    coord: [57.135043, 65.493805],
    descr: "г.Тюмень ул. Московский тракт, 118"
  },
  {
    title: "г. Екатеринбург, ул.Радищева, 33",
    coord: [56.828493, 60.588545],
    descr: "г. Екатеринбург, ул.Радищева, 33"
  },
  {
    title: "г. Екатеринбург, ул. Викулова, 57 А",
    coord: [56.822952, 60.543126],
    descr: "г. Екатеринбург, ул. Викулова, 57 А"
  },
  {
    title: "г. Екатеринбург, б-р Петра Кожемяко , 16 к.2",
    coord: [56.800055, 60.492749],
    descr: "г. Екатеринбург, б-р Петра Кожемяко , 16 к.2"
  },
  {
    title: "г. Екатеринбург, ул.  Евгения Савкова, д. 41",
    coord: [56.78886, 60.48231],
    descr: "г. Екатеринбург, ул.  Евгения Савкова, д. 41"
  },
  {
    title: "г.Пермь, ул. Н.Островского, д.91",
    coord: [58.001957, 56.267954],
    descr: "г.Пермь, ул. Н.Островского, д.91"
  },
  {
    title: "г. Пермь ул. Куйбышева, 37",
    coord: [58.007456, 56.234878],
    descr: "г. Пермь ул. Куйбышева, 37"
  },
  {
    title: "г. Пермь ул. Революции, 24",
    coord: [58.004785, 56.257093],
    descr: "г. Пермь ул. Революции, 24"
  },
  {
    title: "ХМАО-Югра, г. Сургут, пр. Ленина, д. 13",
    coord: [61.250335, 73.400605],
    descr: "ХМАО-Югра, г. Сургут, пр. Ленина, д. 13"
  },
  {
    title: "ХМАО-Югра, г. Сургут, ул. Юности, д.8",
    coord: [61.24818, 73.41823],
    descr: "ХМАО-Югра, г. Сургут, ул. Юности, д.8"
  },
  {
    title: "ХМАО, г.Сургут, ул. Геологическая 10",
    coord: [61.237635, 73.447048],
    descr: "ХМАО, г.Сургут, ул. Геологическая 10"
  },
  {
    title: "г. Тюмень, ул. Орджоникидзе, 63 а",
    coord: [57.148678, 65.541424],
    descr: "г. Тюмень, ул. Орджоникидзе, 63 а"
  },
  {
    title: "г.Тюмень ул. Мельникайте, 137",
    coord: [57.121452, 65.550336],
    descr: "г.Тюмень ул. Мельникайте, 137"
  },
  {
    title: "г.Тюмень, ул. Уездная, 4",
    coord: [57.119903, 65.512921],
    descr: "г.Тюмень, ул. Уездная, 4"
  },
  {
    title: "г.Тюмень, ул. Западносибирская, 19",
    coord: [57.146984, 65.659265],
    descr: "г.Тюмень, ул. Западносибирская, 19"
  },
  {
    title: "г. Челябинск, ул. Братьев Кашириных, 99А",
    coord: [55.177971, 61.348008],
    descr: "г. Челябинск, ул. Братьев Кашириных, 99А"
  },
  {
    title: "г. Челябинск, пр. Ленина, 64 д",
    coord: [55.160602, 61.387938],
    descr: "г. Челябинск, пр. Ленина, 64 д"
  },
  {
    title: "г. Магнитогорск пр-т Карла Маркса д. 210",
    coord: [53.358056, 58.976779],
    descr: "г. Магнитогорск пр-т Карла Маркса д. 210"
  },
  {
    title: "г. Челябинск,  ул .Игуменка 22/ Гражданская, 5а",
    coord: [55.141151, 61.424203],
    descr: "г. Челябинск,  ул .Игуменка 22/ Гражданская, 5а"
  },
  {
    title: "г. Пермь, ул. Пермская, 7",
    coord: [58.016405, 56.25889],
    descr: "г. Пермь, ул. Пермская, 7"
  },
  {
    title: "г.Пермь, Бульвар Гагарина, 91",
    coord: [57.996024, 56.288418],
    descr: "г.Пермь, Бульвар Гагарина, 91"
  },
  {
    title: "г.Челябинск, ул.Тернопольская, д.6",
    coord: [55.156228, 61.370070],
    descr: "г.Челябинск, ул.Тернопольская, д.6"
  },
  {
    title: "Башкортостан, г. Уфа, ул. Магистральная, 2а",
    coord: [54.710994, 55.834634],
    descr: "Башкортостан, г. Уфа, ул. Магистральная, 2а"
  },
  {
    title: "Самарская обл., г. Самара ул. Георгия Димитрова, 1а",
    coord: [53.249941, 50.243978],
    descr: "Самарская обл., г. Самара ул. Георгия Димитрова, 1а"
  },
  {
    title: "Самарская обл., г. Самара, ул. Н. Садовая, 363 б",
    coord: [53.255275, 50.211683],
    descr: "Самарская обл., г. Самара, ул. Н. Садовая, 363 б"
  },
  {
    title: "Батуринская ул., 157/31, Ростов-на-Дону",
    coord: [47.202374, 39.651385],
    descr: "Батуринская ул., 157/31, Ростов-на-Дону"
  },
  {
    title: "г. Ессентуки, ул. Октябрьская, 339",
    coord: [44.044714, 42.880523],
    descr: "г. Ессентуки, ул. Октябрьская, 339"
  },
  {
    title: "Самарская обл., г. Самара, ул. Тухачевского 233",
    coord: [53.198268, 50.160794],
    descr: "Самарская обл., г. Самара, ул. Тухачевского 233"
  },
  {
    title: "Самарская обл., г. Самара, Лесная, 33",
    coord: [53.215483, 50.134096],
    descr: "Самарская обл., г. Самара, Лесная, 33"
  },
  {
    title: "г.Волгоград,  бульвар 30 Лет Победы,  д. 44",
    coord: [48.745329, 44.503033],
    descr: "г.Волгоград,  бульвар 30 Лет Победы,  д. 44"
  },
  {
    title: "г. Краснодар, ул. Восточно-Кругликовская, д. 42/3 с.1",
    coord: [45.053729, 39.028412],
    descr: "г. Краснодар, ул. Восточно-Кругликовская, д. 42/3 с.1"
  },
  {
    title: "Самарская обл.,  г. Тольятти ул Спортивная 4 В",
    coord: [53.499246, 49.287883],
    descr: "Самарская обл.,  г. Тольятти ул Спортивная 4 В"
  },
  {
    title: "г. Краснодар , ул. Атарбекова 1/1",
    coord: [45.060153, 38.942462],
    descr: "г. Краснодар , ул. Атарбекова 1/1"
  },
  {
    title: "Новочеркасск, Магнитный пер. д.1, Лит.А",
    coord: [47.42532, 40.054369],
    descr: "Новочеркасск, Магнитный пер. д.1, Лит.А"
  },
  {
    title: "Башкортостан, г. Уфа, Верхнеторговая площадь, д.1",
    coord: [54.724833, 55.944174],
    descr: "Башкортостан, г. Уфа, Верхнеторговая площадь, д.1"
  },
  {
    title: "Башкортостан, г. Уфа, Академика Королева, 14",
    coord: [54.774457, 56.077484],
    descr: "Башкортостан, г. Уфа, Академика Королева, 14"
  },
  {
    title: "Самарская обл., г. Самара, ул. Н. Садовая, 349",
    coord: [53.253136, 50.209689],
    descr: "Самарская обл., г. Самара, ул. Н. Садовая, 349"
  },
  {
    title: "Самарская обл., г. Самара, ул. Дачная, 2",
    coord: [53.202249, 50.1428],
    descr: "Самарская обл., г. Самара, ул. Дачная, 2"
  },
  {
    title: "Самарская обл., г. Самара, ул. Аэродромная, 13",
    coord: [53.190672, 50.179254],
    descr: "Самарская обл., г. Самара, ул. Аэродромная, 13"
  },
  {
    title: "Самарская обл., г. Самара ул. Солнечная, 24",
    coord: [53.242382, 50.185722],
    descr: "Самарская обл., г. Самара ул. Солнечная, 24"
  },
  {
    title: "Самарская обл., г. Тольятти, ул. Революционная, 52а",
    coord: [53.517913, 49.271902],
    descr: "Самарская обл., г. Тольятти, ул. Революционная, 52а"
  },
  {
    title: "Самарская обл., г. Самара, Ново Садовая, 106",
    coord: [53.217187, 50.148981],
    descr: "Самарская обл., г. Самара, Ново Садовая, 106"
  },
  {
    title: "Ульяновская обл., г. Ульяновск, ул. Радищева, 39",
    coord: [54.327205, 48.401371],
    descr: "Ульяновская обл., г. Ульяновск, ул. Радищева, 39"
  },
  {
    title: "Ульяновская обл., г. Ульяновск, ул. Жигулевская, 9",
    coord: [54.278019, 48.303293],
    descr: "Ульяновская обл., г. Ульяновск, ул. Жигулевская, 9"
  },
  {
    title: "Оренбургская обл., г. Оренбург, ул. 8 марта, 42",
    coord: [54.278019, 48.303293],
    descr: "Оренбургская обл., г. Оренбург, ул. 8 марта, 42"
  },
  {
    title: "Оренбургская обл., г. Оренбург, ул. Пролетарская, д.290А",
    coord: [51.804674, 55.095257],
    descr: "Оренбургская обл., г. Оренбург, ул. Пролетарская, д.290А"
  },
  {
    title: "Пензенская обл., г. Пенза, ул.Плеханова 19",
    coord: [53.200269, 45.012082],
    descr: "Пензенская обл., г. Пенза, ул.Плеханова 19"
  },
  {
    title: "Саратовская обл., г. Саратов, ул.Зарубина, д.167",
    coord: [51.541568, 46.014206],
    descr: "Саратовская обл., г. Саратов, ул.Зарубина, д.167"
  },
  {
    title: "г. Краснодар ул. Чекистов 36/А",
    coord: [45.031751, 38.917479],
    descr: "г. Краснодар ул. Чекистов 36/А"
  },
  {
    title: "Краснодарский край, г. Краснодар, ул. Индустриальная, 2",
    coord: [45.001517, 38.96191],
    descr: "Краснодарский край, г. Краснодар, ул. Индустриальная, 2"
  },
  {
    title: "Темрюк, ул. Розы Люксембург,61",
    coord: [45.279945, 37.378782],
    descr: "Темрюк, ул. Розы Люксембург,61"
  },
  {
    title: "г.Сочи ул Северная  д.6",
    coord: [43.594561, 39.727598],
    descr: "г.Сочи ул Северная  д.6"
  },
  {
    title: "г. Пятигорск,  Ессентукская ул,  31А",
    coord: [44.051219, 43.034207],
    descr: "г. Пятигорск,  Ессентукская ул,  31А"
  },
  {
    title: "г.Волгоград, ул.Рабоче-Крестьянская, д.9Б",
    coord: [48.697036, 44.502027],
    descr: "г.Волгоград, ул.Рабоче-Крестьянская, д.9Б"
  },
  {
    title: "г.Волгоград, ул.Краснознаменская, д.9",
    coord: [48.704273, 44.509492],
    descr: "г.Волгоград, ул.Краснознаменская, д.9"
  },
  {
    title: "г.Астрахань, ул.Минусинская, д.8, лит.Б",
    coord: [46.358873, 48.069749],
    descr: "г.Астрахань, ул.Минусинская, д.8, лит.Б"
  },
  {
    title: "Самарская обл., г. Самара, ул.Зои Космодемьянской, 7а",
    coord: [53.260182, 50.231752],
    descr: "Самарская обл., г. Самара, ул.Зои Космодемьянской, 7а"
  },
  {
    title: "Самарская обл., г. Самара, ул.Чернореченская, 38",
    coord: [53.199794, 50.144399],
    descr: "Самарская обл., г. Самара, ул.Чернореченская, 38"
  },
  {
    title: "Самарская обл., г. Тольятти, ул. Дзержинского, 21",
    coord: [53.533645, 49.319719],
    descr: "Самарская обл., г. Тольятти, ул. Дзержинского, 21"
  },
  {
    title: "Ульяновская обл., г. Ульяновск, пр. Ульяновский, 14",
    coord: [54.374501, 48.582588],
    descr: "Ульяновская обл., г. Ульяновск, пр. Ульяновский, 14"
  },
  {
    title: "Россия г. Ростов-на-Дону пр-т Коммунистический 32",
    coord: [47.208698, 39.62952],
    descr: "Россия г. Ростов-на-Дону пр-т Коммунистический 32"
  },
  {
    title: "г Сочи ул. Учительская д. 6",
    coord: [43.572359, 39.736195],
    descr: "г Сочи ул. Учительская д. 6"
  },
  {
    title: "Самарская обл., г. Самара, ул.Ново-садовая, 305а",
    coord: [53.236507, 50.191184],
    descr: "Самарская обл., г. Самара, ул.Ново-садовая, 305а"
  },
  {
    title: "Самарская обл., г. Самара, ул. Московское ш., 28",
    coord: [53.210258, 50.173316],
    descr: "Самарская обл., г. Самара, ул. Московское ш., 28"
  },
  {
    title: "Самарская обл., г. Самара, ул. Солнечная, 60/126, 9 просека",
    coord: [53.264987, 50.210659],
    descr: "Самарская обл., г. Самара, ул. Солнечная, 60/126, 9 просека"
  },
  {
    title: "Самарская обл., г. Тольятти, ул. Тополиная 44",
    coord: [53.535979, 49.343075],
    descr: "Самарская обл., г. Тольятти, ул. Тополиная 44"
  },
  {
    title: "Оренбургская обл., г. Оренбург, пр.  Гагарина 29/2",
    coord: [51.773878, 55.185197],
    descr: "Оренбургская обл., г. Оренбург, пр.  Гагарина 29/2"
  },
  {
    title: "Пензенская обл.,  г. Пенза ул Суворова 144 а",
    coord: [53.202712, 44.997807],
    descr: "Пензенская обл.,  г. Пенза ул Суворова 144 а"
  },
  {
    title: "Пензенская обл., г. Пенза пр.Строителей 90",
    coord: [53.22157, 44.90909],
    descr: "Пензенская обл., г. Пенза пр.Строителей 90"
  },
  {
    title: "Пензенская обл., г. Пенза, ул.Окружная 27В",
    coord: [53.161759, 44.977793],
    descr: "Пензенская обл., г. Пенза, ул.Окружная 27В"
  },
  {
    title: "Саратовская обл., г. Балаково ул. Трнавская, 24",
    coord: [52.022697, 47.829468],
    descr: "Саратовская обл., г. Балаково ул. Трнавская, 24"
  },
  {
    title: "Саратовская обл., г. Саратов, ул. Московская, 113/117",
    coord: [51.536347, 46.022183],
    descr: "Саратовская обл., г. Саратов, ул. Московская, 113/117"
  },
  {
    title: "г.Саратов, ул. Высокая 12А",
    coord: [51.562149, 46.028382],
    descr: "г.Саратов, ул. Высокая 12А"
  },
  {
    title: "Краснодарский край, г. Краснодар, ул. Красная, 176",
    coord: [45.046871, 38.980029],
    descr: "Краснодарский край, г. Краснодар, ул. Красная, 176"
  },
  {
    title: "г.Краснодар ул.Ставропольская 55",
    coord: [45.02043, 39.000268],
    descr: "г.Краснодар ул.Ставропольская 55"
  },
  {
    title: "РО, г.Новочеркасск,  пр. Платовский д.59а, стр1",
    coord: [47.411004, 40.104064],
    descr: "РО, г.Новочеркасск,  пр. Платовский д.59а, стр1"
  },
  {
    title: "г.Ростов-на-Дону ул. Красноармейская 105",
    coord: [47.23138, 39.72617],
    descr: "г.Ростов-на-Дону ул. Красноармейская 105"
  },
  {
    title: "РО, г.Таганрог, ул.Бакинская, 65",
    coord: [47.276456, 38.915126],
    descr: "РО, г.Таганрог, ул.Бакинская, 65"
  },
  {
    title: "РО г.Таганрог пер.Гоголевский 2/1",
    coord: [47.219397, 38.91986],
    descr: "РО г.Таганрог пер.Гоголевский 2/1"
  },
  {
    title: "Ставропольский край, г. Ставрополь, ул. Артема, 49",
    coord: [45.033827, 41.965185],
    descr: "Ставропольский край, г. Ставрополь, ул. Артема, 49"
  },
  {
    title: "г. Пятигорск ул. Кирова 65",
    coord: [44.03548, 43.065217],
    descr: "г. Пятигорск ул. Кирова 65"
  },
  {
    title: "г. Ставрополь, ул. 45 Параллель, 38 А",
    coord: [44.99935, 41.913271],
    descr: "г. Ставрополь, ул. 45 Параллель, 38 А"
  },
  {
    title: "г. Ставрополь,  ул. Бруснева, 11Б",
    coord: [45.06417, 41.931785],
    descr: "г. Ставрополь,  ул. Бруснева, 11Б"
  },
  {
    title: "Оренбургская обл., г. Оренбург, ул. Салмышская, 66/2",
    coord: [51.813639, 55.175405],
    descr: "Оренбургская обл., г. Оренбург, ул. Салмышская, 66/2"
  },
  {
    title: "Башкортостан, г. Уфа, пр. Октября, 109",
    coord: [54.78452, 56.032775],
    descr: "Башкортостан, г. Уфа, пр. Октября, 109"
  },
  {
    title: "Самарская обл., г. Самара, ул. Белорусская, 131",
    coord: [53.142627, 50.041551],
    descr: "Самарская обл., г. Самара, ул. Белорусская, 131"
  },
  {
    title: "Самарская обл., г.Самара ул.Димитрова 7А",
    coord: [53.25222, 50.239279],
    descr: "Самарская обл., г.Самара ул.Димитрова 7А"
  },
  {
    title: "г.Сочи, ул. Навагинская, 17/5",
    coord: [43.591871, 39.725649],
    descr: "г.Сочи, ул. Навагинская, 17/5"
  },
  {
    title: "Татарстан, г.Казань, Кулахметова, 28",
    coord: [55.829704, 49.062154],
    descr: "Татарстан, г.Казань, Кулахметова, 28"
  },
  {
    title: "г.Ижевск, ул. 10 лет Октября,53",
    coord: [56.873495, 53.223671],
    descr: "г.Ижевск, ул. 10 лет Октября,53"
  },
  {
    title: "Г.Ижевск ул.Ворошилова ,44",
    coord: [56.876102, 53.268416],
    descr: "Г.Ижевск ул.Ворошилова ,44"
  },
  {
    title: "город Ижевск, Республика Удмуртия, Заявьяловский район д.Пирогово, ул.Высотная, 1 «Б»",
    coord: [56.788056, 53.161481],
    descr: "город Ижевск, Республика Удмуртия, Заявьяловский район д.Пирогово, ул.Высотная, 1 «Б»"
  },
  {
    title: "г. С-Петербург,  Косыгина пр., д. 30, корп.1, лит. А",
    coord: [59.946054, 30.497669],
    descr: "г. С-Петербург,  Косыгина пр., д. 30, корп.1, лит. А"
  },
  {
    title: "г. Великий Новгород ул. Большая Санкт-Петербургская д. 130",
    coord: [58.565204, 31.280102],
    descr: "г. Великий Новгород ул. Большая Санкт-Петербургская д. 130"
  },
  {
    title: "Ленинградская обл, Всеволожский р-н, Мурино г, Новая ул , 8",
    coord: [60.041099, 30.44457],
    descr: "Ленинградская обл, Всеволожский р-н, Мурино г, Новая ул , 8"
  },
  {
    title: "г.Сестрорецк ул.Володарского д.2",
    coord: [60.095816, 29.971499],
    descr: "г.Сестрорецк ул.Володарского д.2"
  },
  {
    title: "г. СПб., пр. Энергетиков, д.8, к.1, лит.А, пом. 1Н",
    coord: [59.937851, 30.434643],
    descr: "г. СПб., пр. Энергетиков, д.8, к.1, лит.А, пом. 1Н"
  },
  {
    title: "Пос. Янино, ул. Шоссейная, д,40",
    coord: [59.946216, 30.560803],
    descr: "Пос. Янино, ул. Шоссейная, д,40"
  },
  {
    title: "Республика Удмуртия, г.Ижевск, Славянское ш., 0/24",
    coord: [56.919941, 53.231765],
    descr: "Республика Удмуртия, г.Ижевск, Славянское ш., 0/24"
  },
  {
    title: "Чувашская республика г. Чебоксары проспект Максима Горького д.4",
    coord: [56.148885, 47.200566],
    descr: "Чувашская республика г. Чебоксары проспект Максима Горького д.4"
  },
  {
    title: "610046 г.Киров Октябрьский пр-кт 117 п.1013",
    coord: [58.604139, 49.65639],
    descr: "610046 г.Киров Октябрьский пр-кт 117 п.1013"
  },
  {
    title: "Чувашская республика г. Чебоксары проспект Ивана Яковлева 4б",
    coord: [56.101976, 47.265883],
    descr: "Чувашская республика г. Чебоксары проспект Ивана Яковлева 4б"
  },
  {
    title: "СПБ Ул.Бухарестская 32 ЛИТ 4пом2Н,3Н",
    coord: [59.882699, 30.370504],
    descr: "СПБ Ул.Бухарестская 32 ЛИТ 4пом2Н,3Н"
  },
  {
    title: "СПб пр Культуры 20",
    coord: [60.045722, 30.373028],
    descr: "СПб пр Культуры 20"
  },
  {
    title: "СПб, ул, Симонова 1,  литА",
    coord: [60.055807, 30.323872],
    descr: "СПб, ул, Симонова 1,  литА"
  },
  {
    title: "СПб, Типанова ул. д.21",
    coord: [59.853288, 30.340707],
    descr: "СПб, Типанова ул. д.21"
  },
  {
    title: "г. СПб., Чкаловский проспект, д. 15, лит.А",
    coord: [59.962904, 30.295494],
    descr: "г. СПб., Чкаловский проспект, д. 15, лит.А"
  },
  {
    title: "Г.Ижевск ул.9 января, 219А",
    coord: [56.878374, 53.255642],
    descr: "Г.Ижевск ул.9 января, 219А"
  },
  {
    title: "г.Ижевск,ул.Удмуртская,304",
    coord: [56.858735, 53.223114],
    descr: "г.Ижевск,ул.Удмуртская,304"
  },
  {
    title: "СПБ., пос. Парголово, 4-й Верхний переулок, д.1а,  лит. Б",
    coord: [60.072215, 30.339952],
    descr: "СПБ., пос. Парголово, 4-й Верхний переулок, д.1а,  лит. Б"
  },
  {
    title: "СПБ .Индустриальный проспект ,31",
    coord: [59.950947, 30.473756],
    descr: "СПБ .Индустриальный проспект ,31"
  },
  {
    title: "Татарстан, г.Казань, Сибирский Тракт, 34/1",
    coord: [55.819004, 49.183876],
    descr: "Татарстан, г.Казань, Сибирский Тракт, 34/1"
  },
  {
    title: "Татарстан, г. Казань., ул.Фучика ,  155",
    coord: [55.773434, 49.230462],
    descr: "Татарстан, г. Казань., ул.Фучика ,  155"
  },
  {
    title: "Татарстан, г. Казань, ул. Спартаковская, 6",
    coord: [55.778871, 49.129573],
    descr: "Татарстан, г. Казань, ул. Спартаковская, 6"
  },
  {
    title: "Татарстан, г. Казань, ул. Чистопольская, 69",
    coord: [55.819975, 49.141574],
    descr: "Татарстан, г. Казань, ул. Чистопольская, 69"
  },
  {
    title: "г. Йошкар-Ола, ул. К. маркса , 101",
    coord: [56.627921, 47.896761],
    descr: "г. Йошкар-Ола, ул. К. маркса , 101"
  },
  {
    title: "г.Чебоксары, пр. Мира 82в",
    coord: [56.111695, 47.26794],
    descr: "г.Чебоксары, пр. Мира 82в"
  },
  {
    title: "Татарстан, г. Альметьевск, ул. Ленина, 100",
    coord: [54.899379, 52.274017],
    descr: "Татарстан, г. Альметьевск, ул. Ленина, 100"
  },
  {
    title: "СПб, Балканская пл., д. 5, лит. О",
    coord: [59.830761, 30.377421],
    descr: "СПб, Балканская пл., д. 5, лит. О"
  },
  {
    title: "Спб, Дачный проспект, д 9, корп.1, лит А",
    coord: [59.846554, 30.244362],
    descr: "Спб, Дачный проспект, д 9, корп.1, лит А"
  },
  {
    title: "СПб, Стачек  пр., д.99,  лит. А, пом. 8Н",
    coord: [59.858792, 30.248342],
    descr: "СПб, Стачек  пр., д.99,  лит. А, пом. 8Н"
  },
  {
    title: "СПб, Шлиссельбургский пр.,д. 17/1 лит.А",
    coord: [59.839353, 30.494839],
    descr: "СПб, Шлиссельбургский пр.,д. 17/1 лит.А"
  },
  {
    title: "г. С-Петербург,  Художников пр., д. 13, корп.1, лит. А",
    coord: [60.036784, 30.345917],
    descr: "г. С-Петербург,  Художников пр., д. 13, корп.1, лит. А"
  },
  {
    title: "Татарстан, г. Нижнекамск, ул. Химиков, 18",
    coord: [55.62026, 51.791254],
    descr: "Татарстан, г. Нижнекамск, ул. Химиков, 18"
  },
  {
    title: "СПб, ст. Рыбацкое, участок ж.д, ул. Юнатов-ст.Рыбацкое, лит.Е",
    coord: [59.832398, 30.5013059],
    descr: "СПб, ст. Рыбацкое, участок ж.д, ул. Юнатов-ст.Рыбацкое, лит.Е"
  },
  {
    title: "СПб, Ефимова ул. 2",
    coord: [59.926499, 30.320854],
    descr: "СПб, Ефимова ул. 2"
  },
  {
    title: "СПб, Шоссе Революции, 41/39, лит А",
    coord: [59.959683, 30.439773],
    descr: "СПб, Шоссе Революции, 41/39, лит А"
  },
  {
    title: "СПб, Пражская ул., д.48/50, лит А",
    coord: [59.863328, 30.404083],
    descr: "СПб, Пражская ул., д.48/50, лит А"
  },
  {
    title: "Татарстан, г.Казань, ул.Декабристов, д.79",
    coord: [55.817466, 49.093424],
    descr: "Татарстан, г.Казань, ул.Декабристов, д.79"
  },
  {
    title: "Татарстан, Зеленодольский, село Осиново, ул. Садовая, 9",
    coord: [55.872905, 48.882338],
    descr: "Татарстан, Зеленодольский, село Осиново, ул. Садовая, 9"
  },
  {
    title: "Татарстан, г. Казань, ул.Краснококшайская, 150/2",
    coord: [55.817871, 49.064166],
    descr: "Татарстан, г. Казань, ул.Краснококшайская, 150/2"
  },
  {
    title: "г. Ижевск, ул 10 лет Октября, 43А",
    coord: [56.873495, 53.223671],
    descr: "г. Ижевск, ул 10 лет Октября, 43А"
  },
  {
    title: "Чувашская республика г. Чебоксары проспект Максима Горького д.10/1",
    coord: [56.15073, 47.198087],
    descr: "Чувашская республика г. Чебоксары проспект Максима Горького д.10/1"
  },
  {
    title: "г.Йошкар-Ола, ул.Красноармейская 111",
    coord: [56.644208, 47.858403],
    descr: "г.Йошкар-Ола, ул.Красноармейская 111"
  },
  {
    title: "г.Йошкар-Ола, ул.Анциферова,4",
    coord: [56.651151, 47.862876],
    descr: "г.Йошкар-Ола, ул.Анциферова,4"
  },
  {
    title: "г.Йошкар-Ола, ул.Красноармейская 47",
    coord: [56.640911, 47.892467],
    descr: "г.Йошкар-Ола, ул.Красноармейская 47"
  },
  {
    title: "г. Чебоксары, ул. Ленинградская, д.22",
    coord: [56.143579, 47.247809],
    descr: "г. Чебоксары, ул. Ленинградская, д.22"
  },
  {
    title: "г. Чебоксары пр.Тракторостроителей 36/1",
    coord: [56.102343, 47.309631],
    descr: "г. Чебоксары пр.Тракторостроителей 36/1"
  },
  {
    title: "Татарстан, г. Набережные Челны, пр. Сююмбике, 40",
    coord: [55.751791, 52.409411],
    descr: "Татарстан, г. Набережные Челны, пр. Сююмбике, 40"
  },
  {
    title: "Татарстан, г. Набережные Челны, пр. Мира, 3",
    coord: [55.724895, 52.380962],
    descr: "Татарстан, г. Набережные Челны, пр. Мира, 3"
  },
  {
    title: "СПб, Гражданский пр., д. 41, лит. В",
    coord: [60.01154, 30.397812],
    descr: "СПб, Гражданский пр., д. 41, лит. В"
  },
  {
    title: "СПб, Стачек пл., д. 7, лит. А",
    coord: [59.900723, 30.272219],
    descr: "СПб, Стачек пл., д. 7, лит. А"
  },
  {
    title: "новое Девяткино, ул. Главная 21/23",
    coord: [60.055807, 30.467827],
    descr: "новое Девяткино, ул. Главная 21/23"
  },
  {
    title: "198504, Петергоф, ул Гостилицкая, 2а",
    coord: [59.878513, 29.860108],
    descr: "198504, Петергоф, ул Гостилицкая, 2а"
  },
  {
    title: "ЛО, г. Всеволжск, ул. Героев17",
    coord: [60.032137, 30.632416],
    descr: "ЛО, г. Всеволжск, ул. Героев17"
  },
  {
    title: "Белгородская обл., г. Строитель, ул. 5 Августа, д. 11",
    coord: [50.787285, 36.492028],
    descr: "Белгородская обл., г. Строитель, ул. 5 Августа, д. 11"
  },
  {
    title: "г. Воронеж, Загоровского 1",
    coord: [51.714042, 39.191591],
    descr: "г. Воронеж, Загоровского 1"
  },
  {
    title: "Г.Воронеж ул.Переверткина д1/9",
    coord: [51.682916, 39.255156],
    descr: "Г.Воронеж ул.Переверткина д1/9"
  },
  {
    title: "г. Саранск, ул. Cевастопольская 7/1",
    coord: [54.177253, 45.215954],
    descr: "г. Саранск, ул. Cевастопольская 7/1"
  },
  {
    title: "г.Владимир пр-кт Ленина д.43",
    coord: [56.118189, 40.357766],
    descr: "г.Владимир пр-кт Ленина д.43"
  },
  {
    title: "г.Владимир, ул.Соколова-Соколенка 4Б",
    coord: [56.161038, 40.457973],
    descr: "г.Владимир, ул.Соколова-Соколенка 4Б"
  },
  {
    title: "г. Орел, ул.Гагарина, 51",
    coord: [52.955493, 36.074339],
    descr: "г. Орел, ул.Гагарина, 51"
  },
  {
    title: "г. Ярославль, проспект Фрунзе 38",
    coord: [57.590161, 39.900802],
    descr: "г. Ярославль, проспект Фрунзе 38"
  },
  {
    title: "г.Белгород, ул.Попова, д.36",
    coord: [50.59988, 36.590555],
    descr: "г.Белгород, ул.Попова, д.36"
  },
  {
    title: "Г. Курск ул. Щепкина  д.4-б",
    coord: [51.725859, 36.17513],
    descr: "Г. Курск ул. Щепкина  д.4-б"
  },
  {
    title: "Липецк, ул. Петра Смородина 13А",
    coord: [52.588697, 39.5357],
    descr: "Липецк, ул. Петра Смородина 13А"
  },
  {
    title: "Нижегородская обл. г. Бор ул. Пушкина 102",
    coord: [56.359958, 44.052726],
    descr: "Нижегородская обл. г. Бор ул. Пушкина 102"
  },
  {
    title: "г.Владимир ул. Большая Московская 19а",
    coord: [56.12833, 40.403041],
    descr: "г.Владимир ул. Большая Московская 19а"
  },
  {
    title: "г. Курск, пр-зд Сергеева 13",
    coord: [51.743953, 36.128741],
    descr: "г. Курск, пр-зд Сергеева 13"
  },
  {
    title: "Г.Липецк ул.Водопьянова д. 15",
    coord: [52.590858, 39.545348],
    descr: "Г.Липецк ул.Водопьянова д. 15"
  },
  {
    title: "Липецк, ул. Ленина, д.5",
    coord: [52.61092, 39.602669],
    descr: "Липецк, ул. Ленина, д.5"
  },
  {
    title: "г.Липецк, ул.Московская 103",
    coord: [52.601678, 39.516386],
    descr: "г.Липецк, ул.Московская 103"
  },
  {
    title: "г.Саранск, Советская, 55а",
    coord: [54.18218, 45.180408],
    descr: "г.Саранск, Советская, 55а"
  },
  {
    title: "г.Саранск, ул. Пролетарская д.118",
    coord: [54.193312, 45.176904],
    descr: "г.Саранск, ул. Пролетарская д.118"
  },
  {
    title: "г.Липецк, ул.Ворошилова, д.4",
    coord: [52.603778, 39.590093],
    descr: "г.Липецк, ул.Ворошилова, д.4"
  },
  {
    title: "НН Южное шоссе, 35",
    coord: [56.227945, 43.863675],
    descr: "НН Южное шоссе, 35"
  },
  {
    title: "г.Владимир, Октябрьский пр-кт д.43",
    coord: [56.14078, 40.3891],
    descr: "г.Владимир, Октябрьский пр-кт д.43"
  },
  {
    title: "г. Великий Новгород ул. Большая Санкт-Петербургская д. 130",
    coord: [58.565204, 31.280102],
    descr: "г. Великий Новгород ул. Большая Санкт-Петербургская д. 130"
  },
  {
    title: "г. Санкт-Петербург, Ленская ул, 12, 1,лит.А",
    coord: [59.940528, 30.494211],
    descr: "г. Санкт-Петербург, Ленская ул, 12, 1,лит.А"
  },
  {
    title: "г. Екатеринбург, ул. Малышева, 53",
    coord: [56.836209, 60.6158],
    descr: "г. Екатеринбург, ул. Малышева, 53"
  },
  {
    title: "г. Екатеринбург ул. Мельникова 27",
    coord: [56.833176, 60.569402],
    descr: "г. Екатеринбург ул. Мельникова 27"
  },
  {
    title: "г. Екатеринбург, ул.  Техническая, 63",
    coord: [56.869004, 60.522977],
    descr: "г. Екатеринбург, ул.  Техническая, 63"
  },
  {
    title: "г. Екатеринбург, ул.  Посадская, 24",
    coord: [56.821686, 60.570902],
    descr: "г. Екатеринбург, ул.  Посадская, 24"
  },
  {
    title: "г. Екатеринбург, ул.  Опалихинская, 15",
    coord: [56.848655, 60.564443],
    descr: "г. Екатеринбург, ул.  Опалихинская, 15"
  },
  {
    title: "г. Екатеринбург, ул.8 марта, 188",
    coord: [56.804717, 60.610383],
    descr: "г. Екатеринбург, ул.8 марта, 188"
  },
  {
    title: "г. Екатеринбург, ул. Сулимова, д.50",
    coord: [56.863488, 60.630766],
    descr: "г. Екатеринбург, ул. Сулимова, д.50"
  },
  {
    title: "г. Екатернбург, ул Победы, 65, литер А",
    coord: [56.902162, 60.588321],
    descr: "г. Екатернбург, ул Победы, 65, литер А"
  },
  {
    title: "г. Екатеринбург ул. Серова, 41",
    coord: [56.808088, 60.599271],
    descr: "г. Екатеринбург ул. Серова, 41"
  },
  {
    title: "г. Нижний Тагил, ул. Юности, д.16",
    coord: [57.910225, 60.093475],
    descr: "г. Нижний Тагил, ул. Юности, д.16"
  },
  {
    title: "г. Тобольск, 7-ой мкр., д. 30",
    coord: [58.229197, 68.274827],
    descr: "г. Тобольск, 7-ой мкр., д. 30"
  },
  {
    title: "г. Екатеринбург, ул. Ангарская, 22",
    coord: [56.884374, 60.499226],
    descr: "г. Екатеринбург, ул. Ангарская, 22"
  },
  {
    title: "г. Екатеринбург, ул. Машинистов д.1",
    coord: [56.852416, 60.57454],
    descr: "г. Екатеринбург, ул. Машинистов д.1"
  },
  {
    title: "Самарская обл.Сергея лазо 60",
    coord: [53.34729, 50.2315],
    descr: "Самарская обл.Сергея лазо 60"
  },
  {
    title: "г. Геленджик, ул, Луначарского, 4/1",
    coord: [44.559413, 38.098881],
    descr: "г. Геленджик, ул, Луначарского, 4/1"
  },
  {
    title: "г Анапа ул Омелькова 38",
    coord: [44.878565, 37.336561],
    descr: "г Анапа ул Омелькова 38"
  },
  {
    title: "Саратовская обл., г. Саратов ул.Соколовая 18/40",
    coord: [51.531175, 46.063039],
    descr: "Саратовская обл., г. Саратов ул.Соколовая 18/40"
  },
  {
    title: "Г.Краснодар Суворова 64",
    coord: [45.022864, 38.987359],
    descr: "Г.Краснодар Суворова 64"
  },
  {
    title: "Краснодарский край г. Новороссийск пр. Дзержинского 211",
    coord: [44.684082, 37.778182],
    descr: "Краснодарский край г. Новороссийск пр. Дзержинского 211"
  },
  {
    title: "Самарская обл., г. Новокуйбышевск, ул , пр. Победы, 1Ж",
    coord: [53.101778, 49.958574],
    descr: "Самарская обл., г. Новокуйбышевск, ул , пр. Победы, 1Ж"
  },
  {
    title: "Саратовская обл., г. Энгельс Пл. Ленина 4",
    coord: [51.502586, 46.118393],
    descr: "Саратовская обл., г. Энгельс Пл. Ленина 4"
  },
  {
    title: "г.Волгоград ул.50 лет Октября д.15А",
    coord: [48.520061, 44.562268],
    descr: "г.Волгоград ул.50 лет Октября д.15А"
  },
  {
    title: "г.Геленджик, ул.Халтурина, 30",
    coord: [44.57322, 38.077034],
    descr: "г.Геленджик, ул.Халтурина, 30"
  },
  {
    title: "г Анапа ул Краснодарская 5",
    coord: [44.89621, 37.317293],
    descr: "г Анапа ул Краснодарская 5"
  },
  {
    title: "г. Азов ул. Привокзальная 10б",
    coord: [47.098887, 39.418542],
    descr: "г. Азов ул. Привокзальная 10б"
  },
  {
    title: "Ставрополь, ул. Ленина, 74/17",
    coord: [45.042591, 42.000372],
    descr: "Ставрополь, ул. Ленина, 74/17"
  },
  {
    title: "г.Геленджик ул.Кирова 30",
    coord: [44.557088, 38.078498],
    descr: "г.Геленджик ул.Кирова 30"
  },
  {
    title: "СПб, пр. Энгельса, д.120, лит. А",
    coord: [60.036542, 30.321213],
    descr: "СПб, пр. Энгельса, д.120, лит. А"
  },
  {
    title: "Ленинградская область, Кингисеппский р-он, г. Кингисепп, ул.Октябрьская, д.9",
    coord: [59.376403, 28.607749],
    descr: "Ленинградская область, Кингисеппский р-он, г. Кингисепп, ул.Октябрьская, д.9"
  },
  {
    title: "СПб, Марата ул. д.86",
    coord: [59.918891, 30.339081],
    descr: "СПб, Марата ул. д.86"
  },
  {
    title: "СПб, Просвещения пр., д. 19, лит. А",
    coord: [60.052703, 30.331202],
    descr: "СПб, Просвещения пр., д. 19, лит. А"
  },
  {
    title: "Татарстан, г. Нижнекамск, ул. Вахитов, 47",
    coord: [55.651643, 51.821033],
    descr: "Татарстан, г. Нижнекамск, ул. Вахитов, 47"
  },
  {
    title: "СПб, Богатырский пр., д.7, лит.А",
    coord: [59.999489, 30.283205],
    descr: "СПб, Богатырский пр., д.7, лит.А"
  },
  {
    title: "СПб, Заневский пр. д. 67, к. 2",
    coord: [59.933027, 30.437644],
    descr: "СПб, Заневский пр. д. 67, к. 2"
  },
  {
    title: "СПб, Наставников, д. 35, к.1",
    coord: [59.950244, 30.488237],
    descr: "СПб, Наставников, д. 35, к.1"
  },
  {
    title: "СПб, Культуры пр., д.1, лит. А",
    coord: [60.033706, 30.367755],
    descr: "СПб, Культуры пр., д.1, лит. А"
  },
  {
    title: "ЛО, г.Сосновый Бор, ул. Солнечная, д. 12",
    coord: [59.901143, 29.085877],
    descr: "ЛО, г.Сосновый Бор, ул. Солнечная, д. 12"
  },
  {
    title: "СПб, Просвещения пр., д.81, лит.А",
    coord: [60.037396, 30.406544],
    descr: "СПб, Просвещения пр., д.81, лит.А"
  },
  {
    title: "СПб. Ул.Энгельса. Дом 27",
    coord: [60.005324, 30.328022],
    descr: "СПб. Ул.Энгельса. Дом 27"
  },
  {
    title: "г. Псков, Кузбасской дивизии ул., д. 19",
    coord: [57.823454, 28.289952],
    descr: "г. Псков, Кузбасской дивизии ул., д. 19"
  },
  {
    title: "РМЭ, г. Волжск, ул. 107 бригады, 5е",
    coord: [55.882439, 48.382444],
    descr: "РМЭ, г. Волжск, ул. 107 бригады, 5е"
  },
  {
    title: "г.Ярославль, ул.Победы, д.41",
    coord: [57.627759, 39.871167],
    descr: "г.Ярославль, ул.Победы, д.41"
  },
  {
    title: "р-н Городецкий, г. Заволжье, ул. Железнодорожная, д. 18А",
    coord: [56.64248, 43.399857],
    descr: "р-н Городецкий, г. Заволжье, ул. Железнодорожная, д. 18А"
  },
  {
    title: "Г. Старый Оскол, мкр Дубрава 1, д.23",
    coord: [51.303718, 37.91893],
    descr: "Г. Старый Оскол, мкр Дубрава 1, д.23"
  },
  {
    title: "Тульская обл., г. Новомосковск, ул. Трудовые резервы, 33б",
    coord: [54.015998, 38.286161],
    descr: "Тульская обл., г. Новомосковск, ул. Трудовые резервы, 33б"
  },
  {
    title: "г. Cтарый оскол, ул. Ленина, 22",
    coord: [51.295636, 37.835019],
    descr: "г. Cтарый оскол, ул. Ленина, 22"
  },
  {
    title: "г. Ярославль, Московский проспект, д. 125",
    coord: [57.595365, 39.869334],
    descr: "г. Ярославль, Московский проспект, д. 125"
  },
  {
    title: "г. Ярославль, ул. Калинина, д.  31",
    coord: [57.570555, 39.862902],
    descr: "г. Ярославль, ул. Калинина, д.  31"
  },
  {
    title: "г.Санкт-Петербург Искровский пр. д6 к1",
    coord: [59.914398, 30.459634],
    descr: "г.Санкт-Петербург Искровский пр. д6 к1"
  },
  {
    title: "г. Санкт -Петербург, пр. Испытателей, д. 27",
    coord: [60.006921, 30.274851],
    descr: "г. Санкт -Петербург, пр. Испытателей, д. 27"
  },
  {
    title: "г. Екатеринбург, ул. Тверитина, 45",
    coord: [56.820912, 60.624684],
    descr: "г. Екатеринбург, ул. Тверитина, 45"
  },
  {
    title: "г.Магнитогорск, ул. Герцена, 6",
    coord: [53.430389, 58.973231],
    descr: "г.Магнитогорск, ул. Герцена, 6"
  },
  {
    title: "г. Магнитогорск, ул. К.Маркса, 153",
    coord: [53.378671, 58.981549],
    descr: "г. Магнитогорск, ул. К.Маркса, 153"
  },
  {
    title: "г. Екатеринбург ул. Лучистая, 2",
    coord: [56.74607, 60.570238],
    descr: "г. Екатеринбург ул. Лучистая, 2"
  },
  {
    title: "Самарская обл., г. Сызрань, 50 лет Октября, 54 А",
    coord: [53.121794, 48.399826],
    descr: "Самарская обл., г. Сызрань, 50 лет Октября, 54 А"
  },
  {
    title: "Сочи, Адлерский р-н, северный склон хребта Аибга, СТК Горная карусель",
    coord: [43.683499, 40.266998],
    descr: "Сочи, Адлерский р-н, северный склон хребта Аибга, СТК Горная карусель"
  },
  {
    title: "Ставропольский край, г.Минеральные Воды, ул.22-го Партсъезда.д.102/Советская.28",
    coord: [44.209355, 43.138079],
    descr: "Ставропольский край, г.Минеральные Воды, ул.22-го Партсъезда.д.102/Советская.28"
  },
  {
    title: "г. Черкесск, пр. Ленина 25",
    coord: [44.224214, 42.047327],
    descr: "г. Черкесск, пр. Ленина 25"
  },
  {
    title: "Башкортостан, г. Ишимбай, ул. Стахановская, 35",
    coord: [53.438537, 56.046708],
    descr: "Башкортостан, г. Ишимбай, ул. Стахановская, 35"
  },
  {
    title: "г. Сочи, Адлерский  р-он, ул. Кирова, 58",
    coord: [43.427671, 39.926853],
    descr: "г. Сочи, Адлерский  р-он, ул. Кирова, 58"
  },
  {
    title: "г. Сочи, Адлерский  р-он, ул. Бестужева 1/1",
    coord: [43.418924, 39.923161],
    descr: "г. Сочи, Адлерский  р-он, ул. Бестужева 1/1"
  },
  {
    title: "613050 г. Кирово-Чепецк, пр-т России, д.34",
    coord: [58.544152, 50.043617],
    descr: "613050 г. Кирово-Чепецк, пр-т России, д.34"
  },
  {
    title: "СПб г Зеленогорск ул Вокзальная д 7",
    coord: [60.205934, 29.703684],
    descr: "СПб г Зеленогорск ул Вокзальная д 7"
  },
  {
    title: "СПб, Выборгское шоссе, д.33, лит.А, лит.Г",
    coord: [60.065543, 30.303453],
    descr: "СПб, Выборгское шоссе, д.33, лит.А, лит.Г"
  },
  {
    title: "СПб, Комендантский пр., д.33, к. 1, лит А",
    coord: [60.021834, 30.245278],
    descr: "СПб, Комендантский пр., д.33, к. 1, лит А"
  },
  {
    title: "СПб, Репищева ул, д.13, к.1",
    coord: [60.023632, 30.283951],
    descr: "СПб, Репищева ул, д.13, к.1"
  },
  {
    title: "СПб, Савушкина ул., д. 141, лит. А",
    coord: [59.990899, 30.205789],
    descr: "СПб, Савушкина ул., д. 141, лит. А"
  },
  {
    title: "Санкт-Петербург, ул.Думская,4,литА",
    coord: [59.933113, 30.328337],
    descr: "Санкт-Петербург, ул.Думская,4,литА"
  },
  {
    title: "Лен.обл., Всеволожский р-н, д.Порошкино, Дорога на Мендсары, д.10",
    coord: [60.122071, 30.352995],
    descr: "Лен.обл., Всеволожский р-н, д.Порошкино, Дорога на Мендсары, д.10"
  },
  {
    title: "г. Санкт-Петербург, ул. Савушкина, дом 132, корп.1, лит. А",
    coord: [59.988878, 30.198207],
    descr: "г. Санкт-Петербург, ул. Савушкина, дом 132, корп.1, лит. А"
  },
  {
    title: "г. С-Петербург,  Ветеранов пр., д. 169,к 4",
    coord: [59.840347, 30.114124],
    descr: "г. С-Петербург,  Ветеранов пр., д. 169,к 4"
  },
  {
    title: "Санкт-Петербург, Московское шоссе7, лит.А",
    coord: [59.832322, 30.339224],
    descr: "Санкт-Петербург, Московское шоссе7, лит.А"
  },
  {
    title: "СПб, Просвещения пр., д.37, лит.А, лит.Б",
    coord: [60.047762, 30.355708],
    descr: "СПб, Просвещения пр., д.37, лит.А, лит.Б"
  },
  {
    title: "Санкт-Петербург, Кременчугская ул 11",
    coord: [59.922882, 30.371222],
    descr: "Санкт-Петербург, Кременчугская ул 11"
  },
  {
    title: "г. Тверь,  Комсомольский проспект, д. 11",
    coord: [56.871178, 35.912678],
    descr: "г. Тверь,  Комсомольский проспект, д. 11"
  },
  {
    title: "СПб, Кораблестроителей ул., д. 21, к. 1, лит.А",
    coord: [59.945869, 30.215706],
    descr: "СПб, Кораблестроителей ул., д. 21, к. 1, лит.А"
  },
  {
    title: "г.Тверь, пл. Гагарина, 5",
    coord: [56.846726, 35.944415],
    descr: "г.Тверь, пл. Гагарина, 5"
  },
  {
    title: "г.Тверь, Тверской пр-т, 2",
    coord: [56.853031, 35.907665],
    descr: "г.Тверь, Тверской пр-т, 2"
  },
  {
    title: "г. Тверь,  Вагжанова д.21",
    coord: [56.850476, 35.939951],
    descr: "г. Тверь,  Вагжанова д.21"
  },
  {
    title: "г. Санкт-Петербург, пр-т Энергетиков, д.70, к. 1, лит. А",
    coord: [59.97201, 30.435425],
    descr: "г. Санкт-Петербург, пр-т Энергетиков, д.70, к. 1, лит. А"
  },
  {
    title: "Петрозаводск, Маршала Мерецкова 11",
    coord: [61.776364, 34.370414],
    descr: "Петрозаводск, Маршала Мерецкова 11"
  },
  {
    title: "ЛО, г. Выборг, пр. Победы, 16",
    coord: [60.697776, 28.776003],
    descr: "ЛО, г. Выборг, пр. Победы, 16"
  },
  {
    title: "Нижегородская обл. г. Бор ул. Пушкина 102",
    coord: [56.359958, 44.052726],
    descr: "Нижегородская обл. г. Бор ул. Пушкина 102"
  },
  {
    title: "г. Санкт-Петербург, Наставников пр-кт, 33, к.1,лит.А",
    coord: [59.949082, 30.489432],
    descr: "г. Санкт-Петербург, Наставников пр-кт, 33, к.1,лит.А"
  },
  {
    title: "Санкт-Петербург,  Афонская.25",
    coord: [60.026141, 30.303426],
    descr: "Санкт-Петербург,  Афонская.25"
  },
  {
    title: "Санкт-Петербург, пр. Большевиков д.27 лит.А",
    coord: [59.900491, 30.486793],
    descr: "Санкт-Петербург, пр. Большевиков д.27 лит.А"
  },
  {
    title: "Г. Санкт-Петербург Парашютная,46",
    coord: [60.032357, 30.248216],
    descr: "Г. Санкт-Петербург Парашютная,46"
  },
  {
    title: "г. Санкт-Петербург, Ленинский пр-кт,  94, к.1,лит.А",
    coord: [59.854246, 30.214817],
    descr: "г. Санкт-Петербург, Ленинский пр-кт,  94, к.1,лит.А"
  },
  {
    title: "г. Санкт-Петербург, ул. Камышовая, д.17к1 лит.А",
    coord: [60.006952, 30.244757],
    descr: "г. Санкт-Петербург, ул. Камышовая, д.17к1 лит.А"
  },
  {
    title: "г. Санкт-Петербург, Красное село, Стрельнинское шоссе, д 1",
    coord: [59.742334, 30.093355],
    descr: "г. Санкт-Петербург, Красное село, Стрельнинское шоссе, д 1"
  },
  {
    title: "Санкт-Петербург, Науки 23 лит.А корп1",
    coord: [60.010807, 30.402124],
    descr: "Санкт-Петербург, Науки 23 лит.А корп1"
  },
  {
    title: "Г. Санкт-Петербург Лиговский проспект дом 30 лит А",
    coord: [59.927563, 30.360613],
    descr: "Г. Санкт-Петербург Лиговский проспект дом 30 лит А"
  },
  {
    title: "Санкт - Петербург, Кондратьевский проспект,44, лит.А",
    coord: [59.971235, 30.386377],
    descr: "Санкт - Петербург, Кондратьевский проспект,44, лит.А"
  },
  {
    title: "СПб, Кораблестроителей ул., д. 31, лит. А",
    coord: [59.95361, 30.22018],
    descr: "СПб, Кораблестроителей ул., д. 31, лит. А"
  },
  {
    title: "г. Санкт-Петербург, Ленинский пр. 137 лит.Б",
    coord: [59.851381, 30.277717],
    descr: "г. Санкт-Петербург, Ленинский пр. 137 лит.Б"
  },
  {
    title: "Санкт-Петербург,  Лыжный пер 6, стр1",
    coord: [59.999372, 30.198988],
    descr: "Санкт-Петербург,  Лыжный пер 6, стр1"
  },
  {
    title: "Спб, Львовская ул.,27,лит.А",
    coord: [59.971204, 30.420351],
    descr: "Спб, Львовская ул.,27,лит.А"
  },
  {
    title: "СПб, Средний пр., д. 39/40, 38, лит. Ж",
    coord: [59.959728, 30.281488],
    descr: "СПб, Средний пр., д. 39/40, 38, лит. Ж"
  },
  {
    title: "СПб , Планерная ул. 25, к.1",
    coord: [60.005648, 30.236709],
    descr: "СПб , Планерная ул. 25, к.1"
  },
  {
    title: "пос. Шушары, ЖК Славянка, ул. Полоцкая, д. 10",
    coord: [59.737935, 30.463515],
    descr: "пос. Шушары, ЖК Славянка, ул. Полоцкая, д. 10"
  },
  {
    title: "Санкт - Петербург, ул.Прибрежная д13.лит А",
    coord: [59.834167, 30.5042],
    descr: "Санкт - Петербург, ул.Прибрежная д13.лит А"
  },
  {
    title: "193318, Санкт-Петербург, Пятилеток пр-кт 2",
    coord: [59.919581, 30.465195],
    descr: "193318, Санкт-Петербург, Пятилеток пр-кт 2"
  },
  {
    title: "СПб, Свердловская наб, 60, лит.В",
    coord: [59.95548, 30.409284],
    descr: "СПб, Свердловская наб, 60, лит.В"
  },
  {
    title: "СПб, Аптекарский просп. 18 лит.А",
    coord: [59.974387, 30.319515],
    descr: "СПб, Аптекарский просп. 18 лит.А"
  },
  {
    title: "СПб, Уточкина ул., д.4, к.1, лит.А, лит.Б",
    coord: [60.011121, 30.262463],
    descr: "СПб, Уточкина ул., д.4, к.1, лит.А, лит.Б"
  },
  {
    title: "СПб, б-р Новаторов, д.11, лит.А",
    coord: [59.849739, 30.267758],
    descr: "СПб, б-р Новаторов, д.11, лит.А"
  },
  {
    title: "СПб, Малый пр., д. 88, лит. А",
    coord: [59.938257, 30.230627],
    descr: "СПб, Малый пр., д. 88, лит. А"
  },
  {
    title: "Санкт –Петербург, Шушары п, Новгородский пр, участок 2",
    coord: [59.810659, 30.369374],
    descr: "Санкт –Петербург, Шушары п, Новгородский пр, участок 2"
  },
  {
    title: "СПб, Морская наб., д. 33-35",
    coord: [59.959278, 30.219614],
    descr: "СПб, Морская наб., д. 33-35"
  },
  {
    title: "г. Санкт-Петербург, Тихая ул., 3, строение 1",
    coord: [59.861318, 30.458242],
    descr: "г. Санкт-Петербург, Тихая ул., 3, строение 1"
  },
  {
    title: "СПб, Кронверкская ул., д.5",
    coord: [59.958174, 30.313173],
    descr: "СПб, Кронверкская ул., д.5"
  },
  {
    title: "г. Санкт-Петербург, ул. Подвойского, д. 37, лит. А",
    coord: [59.917556, 30.497085],
    descr: "г. Санкт-Петербург, ул. Подвойского, д. 37, лит. А"
  },
  {
    title: "г.Тверь, бульвар Цанова,8",
    coord: [56.830014, 35.917547],
    descr: "г.Тверь, бульвар Цанова,8"
  },
  {
    title: "Самарская обл.,  г. Тольятти, ул. Ворошилова, д.23а",
    coord: [53.534057, 49.315254],
    descr: "Самарская обл.,  г. Тольятти, ул. Ворошилова, д.23а"
  },
  {
    title: "г. Воронеж,ул. Маршалла Жукова, д. 15",
    coord: [51.715537, 39.171092],
    descr: "г. Воронеж,ул. Маршалла Жукова, д. 15"
  },
  {
    title: "г.Тула, ул. Советская, д.47",
    coord: [54.191779, 37.618857],
    descr: "г.Тула, ул. Советская, д.47"
  },
  {
    title: "Нижегородская обл., г. Городец, ул. Пролетарская , дом 8",
    coord: [56.646910, 43.470216],
    descr: "Нижегородская обл., г. Городец, ул. Пролетарская , дом 8"
  },
  {
    title: "г.Ярославль, проспект Машиностроителей 9",
    coord: [57.651499, 39.949455],
    descr: "г.Ярославль, проспект Машиностроителей 9"
  },
  {
    title: "г. Санкт-Петербург, Лахтинский пр-кт 85, к.2,лит.А",
    coord: [59.994305, 30.15042],
    descr: "г. Санкт-Петербург, Лахтинский пр-кт 85, к.2,лит.А"
  },
  {
    title: "г. Санкт-Петербург, Коломяжский пр-кт 15, корпус 2, лит А",
    coord: [60.000759, 30.30156],
    descr: "г. Санкт-Петербург, Коломяжский пр-кт 15, корпус 2, лит А"
  },
  {
    title: "г. Березовский, Березовский тракт, 15",
    coord: [56.890157, 60.744708],
    descr: "г. Березовский, Березовский тракт, 15"
  },
  {
    title: "ХМАО, г. Нижневартовск, ул. Чапаева, 27",
    coord: [60.939611, 76.597853],
    descr: "ХМАО, г. Нижневартовск, ул. Чапаева, 27"
  },
  {
    title: "г. Саров, ул Московская, 4",
    coord: [54.939889, 43.326096],
    descr: "г. Саров, ул Московская, 4"
  },
  {
    title: "г. Арзамас ул Парковая 1а",
    coord: [55.400834, 43.831866],
    descr: "г. Арзамас ул Парковая 1а"
  },
  {
    title: "Батуринская ул., 157/31, Ростов-на-Дону",
    coord: [47.202374, 39.651385],
    descr: "Батуринская ул., 157/31, Ростов-на-Дону"
  },
  {
    title: "г.Липецк ул Бехтеева 9",
    coord: [52.602061, 39.510925],
    descr: "г.Липецк ул Бехтеева 9"
  },
  {
    title: "МО, Московская область, Ленинский р-н, д. Сапроново 2, микрорайон Купелинка, квартал Северный, д. Сапроново",
    coord: [55.53727863483943, 37.7224571322632],
    descr: "МО, Московская область, Ленинский р-н, д. Сапроново 2, микрорайон Купелинка, квартал Северный, д. Сапроново"
  },
  {
    title: "МО, д. Алабино 92",
    coord: [55.524885, 37.019654],
    descr: "МО, д. Алабино 92"
  },
  {
    title: "г. Москва Коровинское ш., д.24 к.1",
    coord: [55.882298, 37.519934],
    descr: "г. Москва Коровинское ш., д.24 к.1"
  },
  {
    title: "МО, село Ознобишино 187 ТЦ Грин Парк",
    coord: [55.395300, 37.433160],
    descr: "МО, село Ознобишино 187 ТЦ Грин Парк"
  },
];